const Counties = [
    {
      "fip": 1001,
      "county_name": "Autauga",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1003,
      "county_name": "Baldwin",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1005,
      "county_name": "Barbour",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1007,
      "county_name": "Bibb",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1009,
      "county_name": "Blount",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1011,
      "county_name": "Bullock",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1013,
      "county_name": "Butler",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1015,
      "county_name": "Calhoun",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1017,
      "county_name": "Chambers",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1019,
      "county_name": "Cherokee",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1021,
      "county_name": "Chilton",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1023,
      "county_name": "Choctaw",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1025,
      "county_name": "Clarke",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1027,
      "county_name": "Clay",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1029,
      "county_name": "Cleburne",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1031,
      "county_name": "Coffee",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1033,
      "county_name": "Colbert",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1035,
      "county_name": "Conecuh",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1037,
      "county_name": "Coosa",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1039,
      "county_name": "Covington",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1041,
      "county_name": "Crenshaw",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1043,
      "county_name": "Cullman",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1045,
      "county_name": "Dale",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1047,
      "county_name": "Dallas",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1049,
      "county_name": "DeKalb",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1051,
      "county_name": "Elmore",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1053,
      "county_name": "Escambia",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1055,
      "county_name": "Etowah",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1057,
      "county_name": "Fayette",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1059,
      "county_name": "Franklin",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1061,
      "county_name": "Geneva",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1063,
      "county_name": "Greene",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1065,
      "county_name": "Hale",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1067,
      "county_name": "Henry",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1069,
      "county_name": "Houston",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1071,
      "county_name": "Jackson",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1073,
      "county_name": "Jefferson",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1075,
      "county_name": "Lamar",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1077,
      "county_name": "Lauderdale",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1079,
      "county_name": "Lawrence",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1081,
      "county_name": "Lee",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1083,
      "county_name": "Limestone",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1085,
      "county_name": "Lowndes",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1087,
      "county_name": "Macon",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1089,
      "county_name": "Madison",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1091,
      "county_name": "Marengo",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1093,
      "county_name": "Marion",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1095,
      "county_name": "Marshall",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1097,
      "county_name": "Mobile",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1099,
      "county_name": "Monroe",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1101,
      "county_name": "Montgomery",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1103,
      "county_name": "Morgan",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1105,
      "county_name": "Perry",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1107,
      "county_name": "Pickens",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1109,
      "county_name": "Pike",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1111,
      "county_name": "Randolph",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1113,
      "county_name": "Russell",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1115,
      "county_name": "St. Clair",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1117,
      "county_name": "Shelby",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1119,
      "county_name": "Sumter",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1121,
      "county_name": "Talladega",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1123,
      "county_name": "Tallapoosa",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1125,
      "county_name": "Tuscaloosa",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1127,
      "county_name": "Walker",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1129,
      "county_name": "Washington",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1131,
      "county_name": "Wilcox",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 1133,
      "county_name": "Winston",
      "state": "AL",
      "state_name": "Alabama"
    },
    {
      "fip": 2013,
      "county_name": "Aleutians East Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2016,
      "county_name": "Aleutians West Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2020,
      "county_name": "Anchorage Municipality",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2050,
      "county_name": "Bethel Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2060,
      "county_name": "Bristol Bay Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2068,
      "county_name": "Denali Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2070,
      "county_name": "Dillingham Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2090,
      "county_name": "Fairbanks North Star Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2100,
      "county_name": "Haines Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2105,
      "county_name": "Hoonah-Angoon Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2110,
      "county_name": "Juneau City and Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2122,
      "county_name": "Kenai Peninsula Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2130,
      "county_name": "Ketchikan Gateway Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2150,
      "county_name": "Kodiak Island Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2158,
      "county_name": "Kusilvak Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2164,
      "county_name": "Lake and Peninsula Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2170,
      "county_name": "Matanuska-Susitna Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2180,
      "county_name": "Nome Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2185,
      "county_name": "North Slope Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2188,
      "county_name": "Northwest Arctic Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2195,
      "county_name": "Petersburg Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2198,
      "county_name": "Prince of Wales-Hyder Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2220,
      "county_name": "Sitka City and Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2230,
      "county_name": "Skagway Municipality",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2240,
      "county_name": "Southeast Fairbanks Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2261,
      "county_name": "Valdez-Cordova Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2270,
      "county_name": "Wade Hampton Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2275,
      "county_name": "Wrangell City and Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2282,
      "county_name": "Yakutat City and Borough",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 2290,
      "county_name": "Yukon-Koyukuk Census Area",
      "state": "AK",
      "state_name": "Alaska"
    },
    {
      "fip": 4001,
      "county_name": "Apache",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4003,
      "county_name": "Cochise",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4005,
      "county_name": "Coconino",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4007,
      "county_name": "Gila",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4009,
      "county_name": "Graham",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4011,
      "county_name": "Greenlee",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4012,
      "county_name": "La Paz",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4013,
      "county_name": "Maricopa",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4015,
      "county_name": "Mohave",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4017,
      "county_name": "Navajo",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4019,
      "county_name": "Pima",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4021,
      "county_name": "Pinal",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4023,
      "county_name": "Santa Cruz",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4025,
      "county_name": "Yavapai",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 4027,
      "county_name": "Yuma",
      "state": "AZ",
      "state_name": "Arizona"
    },
    {
      "fip": 5001,
      "county_name": "Arkansas",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5003,
      "county_name": "Ashley",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5005,
      "county_name": "Baxter",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5007,
      "county_name": "Benton",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5009,
      "county_name": "Boone",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5011,
      "county_name": "Bradley",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5013,
      "county_name": "Calhoun",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5015,
      "county_name": "Carroll",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5017,
      "county_name": "Chicot",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5019,
      "county_name": "Clark",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5021,
      "county_name": "Clay",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5023,
      "county_name": "Cleburne",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5025,
      "county_name": "Cleveland",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5027,
      "county_name": "Columbia",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5029,
      "county_name": "Conway",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5031,
      "county_name": "Craighead",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5033,
      "county_name": "Crawford",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5035,
      "county_name": "Crittenden",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5037,
      "county_name": "Cross",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5039,
      "county_name": "Dallas",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5041,
      "county_name": "Desha",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5043,
      "county_name": "Drew",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5045,
      "county_name": "Faulkner",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5047,
      "county_name": "Franklin",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5049,
      "county_name": "Fulton",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5051,
      "county_name": "Garland",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5053,
      "county_name": "Grant",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5055,
      "county_name": "Greene",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5057,
      "county_name": "Hempstead",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5059,
      "county_name": "Hot Spring",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5061,
      "county_name": "Howard",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5063,
      "county_name": "Independence",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5065,
      "county_name": "Izard",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5067,
      "county_name": "Jackson",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5069,
      "county_name": "Jefferson",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5071,
      "county_name": "Johnson",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5073,
      "county_name": "Lafayette",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5075,
      "county_name": "Lawrence",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5077,
      "county_name": "Lee",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5079,
      "county_name": "Lincoln",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5081,
      "county_name": "Little River",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5083,
      "county_name": "Logan",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5085,
      "county_name": "Lonoke",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5087,
      "county_name": "Madison",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5089,
      "county_name": "Marion",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5091,
      "county_name": "Miller",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5093,
      "county_name": "Mississippi",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5095,
      "county_name": "Monroe",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5097,
      "county_name": "Montgomery",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5099,
      "county_name": "Nevada",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5101,
      "county_name": "Newton",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5103,
      "county_name": "Ouachita",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5105,
      "county_name": "Perry",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5107,
      "county_name": "Phillips",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5109,
      "county_name": "Pike",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5111,
      "county_name": "Poinsett",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5113,
      "county_name": "Polk",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5115,
      "county_name": "Pope",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5117,
      "county_name": "Prairie",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5119,
      "county_name": "Pulaski",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5121,
      "county_name": "Randolph",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5123,
      "county_name": "St. Francis",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5125,
      "county_name": "Saline",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5127,
      "county_name": "Scott",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5129,
      "county_name": "Searcy",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5131,
      "county_name": "Sebastian",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5133,
      "county_name": "Sevier",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5135,
      "county_name": "Sharp",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5137,
      "county_name": "Stone",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5139,
      "county_name": "Union",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5141,
      "county_name": "Van Buren",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5143,
      "county_name": "Washington",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5145,
      "county_name": "White",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5147,
      "county_name": "Woodruff",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 5149,
      "county_name": "Yell",
      "state": "AR",
      "state_name": "Arkansas"
    },
    {
      "fip": 6001,
      "county_name": "Alameda",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6003,
      "county_name": "Alpine",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6005,
      "county_name": "Amador",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6007,
      "county_name": "Butte",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6009,
      "county_name": "Calaveras",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6011,
      "county_name": "Colusa",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6013,
      "county_name": "Contra Costa",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6015,
      "county_name": "Del Norte",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6017,
      "county_name": "El Dorado",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6019,
      "county_name": "Fresno",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6021,
      "county_name": "Glenn",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6023,
      "county_name": "Humboldt",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6025,
      "county_name": "Imperial",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6027,
      "county_name": "Inyo",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6029,
      "county_name": "Kern",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6031,
      "county_name": "Kings",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6033,
      "county_name": "Lake",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6035,
      "county_name": "Lassen",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6037,
      "county_name": "Los Angeles",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6039,
      "county_name": "Madera",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6041,
      "county_name": "Marin",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6043,
      "county_name": "Mariposa",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6045,
      "county_name": "Mendocino",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6047,
      "county_name": "Merced",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6049,
      "county_name": "Modoc",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6051,
      "county_name": "Mono",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6053,
      "county_name": "Monterey",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6055,
      "county_name": "Napa",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6057,
      "county_name": "Nevada",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6059,
      "county_name": "Orange",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6061,
      "county_name": "Placer",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6063,
      "county_name": "Plumas",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6065,
      "county_name": "Riverside",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6067,
      "county_name": "Sacramento",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6069,
      "county_name": "San Benito",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6071,
      "county_name": "San Bernardino",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6073,
      "county_name": "San Diego",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6075,
      "county_name": "San Francisco",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6077,
      "county_name": "San Joaquin",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6079,
      "county_name": "San Luis Obispo",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6081,
      "county_name": "San Mateo",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6083,
      "county_name": "Santa Barbara",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6085,
      "county_name": "Santa Clara",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6087,
      "county_name": "Santa Cruz",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6089,
      "county_name": "Shasta",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6091,
      "county_name": "Sierra",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6093,
      "county_name": "Siskiyou",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6095,
      "county_name": "Solano",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6097,
      "county_name": "Sonoma",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6099,
      "county_name": "Stanislaus",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6101,
      "county_name": "Sutter",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6103,
      "county_name": "Tehama",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6105,
      "county_name": "Trinity",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6107,
      "county_name": "Tulare",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6109,
      "county_name": "Tuolumne",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6111,
      "county_name": "Ventura",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6113,
      "county_name": "Yolo",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 6115,
      "county_name": "Yuba",
      "state": "CA",
      "state_name": "California"
    },
    {
      "fip": 8001,
      "county_name": "Adams",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8003,
      "county_name": "Alamosa",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8005,
      "county_name": "Arapahoe",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8007,
      "county_name": "Archuleta",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8009,
      "county_name": "Baca",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8011,
      "county_name": "Bent",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8013,
      "county_name": "Boulder",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8014,
      "county_name": "Broomfield",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8015,
      "county_name": "Chaffee",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8017,
      "county_name": "Cheyenne",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8019,
      "county_name": "Clear Creek",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8021,
      "county_name": "Conejos",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8023,
      "county_name": "Costilla",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8025,
      "county_name": "Crowley",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8027,
      "county_name": "Custer",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8029,
      "county_name": "Delta",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8031,
      "county_name": "Denver",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8033,
      "county_name": "Dolores",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8035,
      "county_name": "Douglas",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8037,
      "county_name": "Eagle",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8039,
      "county_name": "Elbert",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8041,
      "county_name": "El Paso",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8043,
      "county_name": "Fremont",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8045,
      "county_name": "Garfield",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8047,
      "county_name": "Gilpin",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8049,
      "county_name": "Grand",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8051,
      "county_name": "Gunnison",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8053,
      "county_name": "Hinsdale",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8055,
      "county_name": "Huerfano",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8057,
      "county_name": "Jackson",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8059,
      "county_name": "Jefferson",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8061,
      "county_name": "Kiowa",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8063,
      "county_name": "Kit Carson",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8065,
      "county_name": "Lake",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8067,
      "county_name": "La Plata",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8069,
      "county_name": "Larimer",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8071,
      "county_name": "Las Animas",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8073,
      "county_name": "Lincoln",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8075,
      "county_name": "Logan",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8077,
      "county_name": "Mesa",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8079,
      "county_name": "Mineral",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8081,
      "county_name": "Moffat",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8083,
      "county_name": "Montezuma",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8085,
      "county_name": "Montrose",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8087,
      "county_name": "Morgan",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8089,
      "county_name": "Otero",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8091,
      "county_name": "Ouray",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8093,
      "county_name": "Park",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8095,
      "county_name": "Phillips",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8097,
      "county_name": "Pitkin",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8099,
      "county_name": "Prowers",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8101,
      "county_name": "Pueblo",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8103,
      "county_name": "Rio Blanco",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8105,
      "county_name": "Rio Grande",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8107,
      "county_name": "Routt",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8109,
      "county_name": "Saguache",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8111,
      "county_name": "San Juan",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8113,
      "county_name": "San Miguel",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8115,
      "county_name": "Sedgwick",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8117,
      "county_name": "Summit",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8119,
      "county_name": "Teller",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8121,
      "county_name": "Washington",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8123,
      "county_name": "Weld",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 8125,
      "county_name": "Yuma",
      "state": "CO",
      "state_name": "Colorado"
    },
    {
      "fip": 9001,
      "county_name": "Fairfield",
      "state": "CT",
      "state_name": "Connecticut"
    },
    {
      "fip": 9003,
      "county_name": "Hartford",
      "state": "CT",
      "state_name": "Connecticut"
    },
    {
      "fip": 9005,
      "county_name": "Litchfield",
      "state": "CT",
      "state_name": "Connecticut"
    },
    {
      "fip": 9007,
      "county_name": "Middlesex",
      "state": "CT",
      "state_name": "Connecticut"
    },
    {
      "fip": 9009,
      "county_name": "New Haven",
      "state": "CT",
      "state_name": "Connecticut"
    },
    {
      "fip": 9011,
      "county_name": "New London",
      "state": "CT",
      "state_name": "Connecticut"
    },
    {
      "fip": 9013,
      "county_name": "Tolland",
      "state": "CT",
      "state_name": "Connecticut"
    },
    {
      "fip": 9015,
      "county_name": "Windham",
      "state": "CT",
      "state_name": "Connecticut"
    },
    {
      "fip": 10001,
      "county_name": "Kent",
      "state": "DE",
      "state_name": "Delaware"
    },
    {
      "fip": 10003,
      "county_name": "New Castle",
      "state": "DE",
      "state_name": "Delaware"
    },
    {
      "fip": 10005,
      "county_name": "Sussex",
      "state": "DE",
      "state_name": "Delaware"
    },
    {
      "fip": 11001,
      "county_name": "District of Columbia",
      "state": "DC",
      "state_name": "District of Columbia"
    },
    {
      "fip": 12001,
      "county_name": "Alachua",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12003,
      "county_name": "Baker",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12005,
      "county_name": "Bay",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12007,
      "county_name": "Bradford",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12009,
      "county_name": "Brevard",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12011,
      "county_name": "Broward",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12013,
      "county_name": "Calhoun",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12015,
      "county_name": "Charlotte",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12017,
      "county_name": "Citrus",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12019,
      "county_name": "Clay",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12021,
      "county_name": "Collier",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12023,
      "county_name": "Columbia",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12027,
      "county_name": "DeSoto",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12029,
      "county_name": "Dixie",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12031,
      "county_name": "Duval",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12033,
      "county_name": "Escambia",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12035,
      "county_name": "Flagler",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12037,
      "county_name": "Franklin",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12039,
      "county_name": "Gadsden",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12041,
      "county_name": "Gilchrist",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12043,
      "county_name": "Glades",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12045,
      "county_name": "Gulf",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12047,
      "county_name": "Hamilton",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12049,
      "county_name": "Hardee",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12051,
      "county_name": "Hendry",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12053,
      "county_name": "Hernando",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12055,
      "county_name": "Highlands",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12057,
      "county_name": "Hillsborough",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12059,
      "county_name": "Holmes",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12061,
      "county_name": "Indian River",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12063,
      "county_name": "Jackson",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12065,
      "county_name": "Jefferson",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12067,
      "county_name": "Lafayette",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12069,
      "county_name": "Lake",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12071,
      "county_name": "Lee",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12073,
      "county_name": "Leon",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12075,
      "county_name": "Levy",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12077,
      "county_name": "Liberty",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12079,
      "county_name": "Madison",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12081,
      "county_name": "Manatee",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12083,
      "county_name": "Marion",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12085,
      "county_name": "Martin",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12086,
      "county_name": "Miami-Dade",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12087,
      "county_name": "Monroe",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12089,
      "county_name": "Nassau",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12091,
      "county_name": "Okaloosa",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12093,
      "county_name": "Okeechobee",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12095,
      "county_name": "Orange",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12097,
      "county_name": "Osceola",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12099,
      "county_name": "Palm Beach",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12101,
      "county_name": "Pasco",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12103,
      "county_name": "Pinellas",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12105,
      "county_name": "Polk",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12107,
      "county_name": "Putnam",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12109,
      "county_name": "St. Johns",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12111,
      "county_name": "St. Lucie",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12113,
      "county_name": "Santa Rosa",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12115,
      "county_name": "Sarasota",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12117,
      "county_name": "Seminole",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12119,
      "county_name": "Sumter",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12121,
      "county_name": "Suwannee",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12123,
      "county_name": "Taylor",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12125,
      "county_name": "Union",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12127,
      "county_name": "Volusia",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12129,
      "county_name": "Wakulla",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12131,
      "county_name": "Walton",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 12133,
      "county_name": "Washington",
      "state": "FL",
      "state_name": "Florida"
    },
    {
      "fip": 13001,
      "county_name": "Appling",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13003,
      "county_name": "Atkinson",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13005,
      "county_name": "Bacon",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13007,
      "county_name": "Baker",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13009,
      "county_name": "Baldwin",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13011,
      "county_name": "Banks",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13013,
      "county_name": "Barrow",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13015,
      "county_name": "Bartow",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13017,
      "county_name": "Ben Hill",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13019,
      "county_name": "Berrien",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13021,
      "county_name": "Bibb",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13023,
      "county_name": "Bleckley",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13025,
      "county_name": "Brantley",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13027,
      "county_name": "Brooks",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13029,
      "county_name": "Bryan",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13031,
      "county_name": "Bulloch",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13033,
      "county_name": "Burke",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13035,
      "county_name": "Butts",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13037,
      "county_name": "Calhoun",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13039,
      "county_name": "Camden",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13043,
      "county_name": "Candler",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13045,
      "county_name": "Carroll",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13047,
      "county_name": "Catoosa",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13049,
      "county_name": "Charlton",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13051,
      "county_name": "Chatham",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13053,
      "county_name": "Chattahoochee",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13055,
      "county_name": "Chattooga",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13057,
      "county_name": "Cherokee",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13059,
      "county_name": "Clarke",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13061,
      "county_name": "Clay",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13063,
      "county_name": "Clayton",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13065,
      "county_name": "Clinch",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13067,
      "county_name": "Cobb",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13069,
      "county_name": "Coffee",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13071,
      "county_name": "Colquitt",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13073,
      "county_name": "Columbia",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13075,
      "county_name": "Cook",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13077,
      "county_name": "Coweta",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13079,
      "county_name": "Crawford",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13081,
      "county_name": "Crisp",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13083,
      "county_name": "Dade",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13085,
      "county_name": "Dawson",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13087,
      "county_name": "Decatur",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13089,
      "county_name": "DeKalb",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13091,
      "county_name": "Dodge",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13093,
      "county_name": "Dooly",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13095,
      "county_name": "Dougherty",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13097,
      "county_name": "Douglas",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13099,
      "county_name": "Early",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13101,
      "county_name": "Echols",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13103,
      "county_name": "Effingham",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13105,
      "county_name": "Elbert",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13107,
      "county_name": "Emanuel",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13109,
      "county_name": "Evans",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13111,
      "county_name": "Fannin",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13113,
      "county_name": "Fayette",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13115,
      "county_name": "Floyd",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13117,
      "county_name": "Forsyth",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13119,
      "county_name": "Franklin",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13121,
      "county_name": "Fulton",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13123,
      "county_name": "Gilmer",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13125,
      "county_name": "Glascock",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13127,
      "county_name": "Glynn",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13129,
      "county_name": "Gordon",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13131,
      "county_name": "Grady",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13133,
      "county_name": "Greene",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13135,
      "county_name": "Gwinnett",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13137,
      "county_name": "Habersham",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13139,
      "county_name": "Hall",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13141,
      "county_name": "Hancock",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13143,
      "county_name": "Haralson",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13145,
      "county_name": "Harris",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13147,
      "county_name": "Hart",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13149,
      "county_name": "Heard",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13151,
      "county_name": "Henry",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13153,
      "county_name": "Houston",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13155,
      "county_name": "Irwin",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13157,
      "county_name": "Jackson",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13159,
      "county_name": "Jasper",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13161,
      "county_name": "Jeff Davis",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13163,
      "county_name": "Jefferson",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13165,
      "county_name": "Jenkins",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13167,
      "county_name": "Johnson",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13169,
      "county_name": "Jones",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13171,
      "county_name": "Lamar",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13173,
      "county_name": "Lanier",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13175,
      "county_name": "Laurens",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13177,
      "county_name": "Lee",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13179,
      "county_name": "Liberty",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13181,
      "county_name": "Lincoln",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13183,
      "county_name": "Long",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13185,
      "county_name": "Lowndes",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13187,
      "county_name": "Lumpkin",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13189,
      "county_name": "McDuffie",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13191,
      "county_name": "McIntosh",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13193,
      "county_name": "Macon",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13195,
      "county_name": "Madison",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13197,
      "county_name": "Marion",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13199,
      "county_name": "Meriwether",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13201,
      "county_name": "Miller",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13205,
      "county_name": "Mitchell",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13207,
      "county_name": "Monroe",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13209,
      "county_name": "Montgomery",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13211,
      "county_name": "Morgan",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13213,
      "county_name": "Murray",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13215,
      "county_name": "Muscogee",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13217,
      "county_name": "Newton",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13219,
      "county_name": "Oconee",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13221,
      "county_name": "Oglethorpe",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13223,
      "county_name": "Paulding",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13225,
      "county_name": "Peach",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13227,
      "county_name": "Pickens",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13229,
      "county_name": "Pierce",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13231,
      "county_name": "Pike",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13233,
      "county_name": "Polk",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13235,
      "county_name": "Pulaski",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13237,
      "county_name": "Putnam",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13239,
      "county_name": "Quitman",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13241,
      "county_name": "Rabun",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13243,
      "county_name": "Randolph",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13245,
      "county_name": "Richmond",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13247,
      "county_name": "Rockdale",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13249,
      "county_name": "Schley",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13251,
      "county_name": "Screven",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13253,
      "county_name": "Seminole",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13255,
      "county_name": "Spalding",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13257,
      "county_name": "Stephens",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13259,
      "county_name": "Stewart",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13261,
      "county_name": "Sumter",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13263,
      "county_name": "Talbot",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13265,
      "county_name": "Taliaferro",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13267,
      "county_name": "Tattnall",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13269,
      "county_name": "Taylor",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13271,
      "county_name": "Telfair",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13273,
      "county_name": "Terrell",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13275,
      "county_name": "Thomas",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13277,
      "county_name": "Tift",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13279,
      "county_name": "Toombs",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13281,
      "county_name": "Towns",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13283,
      "county_name": "Treutlen",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13285,
      "county_name": "Troup",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13287,
      "county_name": "Turner",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13289,
      "county_name": "Twiggs",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13291,
      "county_name": "Union",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13293,
      "county_name": "Upson",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13295,
      "county_name": "Walker",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13297,
      "county_name": "Walton",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13299,
      "county_name": "Ware",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13301,
      "county_name": "Warren",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13303,
      "county_name": "Washington",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13305,
      "county_name": "Wayne",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13307,
      "county_name": "Webster",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13309,
      "county_name": "Wheeler",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13311,
      "county_name": "White",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13313,
      "county_name": "Whitfield",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13315,
      "county_name": "Wilcox",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13317,
      "county_name": "Wilkes",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13319,
      "county_name": "Wilkinson",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 13321,
      "county_name": "Worth",
      "state": "GA",
      "state_name": "Georgia"
    },
    {
      "fip": 15001,
      "county_name": "Hawaii",
      "state": "HI",
      "state_name": "Hawaii"
    },
    {
      "fip": 15003,
      "county_name": "Honolulu",
      "state": "HI",
      "state_name": "Hawaii"
    },
    {
      "fip": 15005,
      "county_name": "Kalawao",
      "state": "HI",
      "state_name": "Hawaii"
    },
    {
      "fip": 15007,
      "county_name": "Kauai",
      "state": "HI",
      "state_name": "Hawaii"
    },
    {
      "fip": 15009,
      "county_name": "Maui",
      "state": "HI",
      "state_name": "Hawaii"
    },
    {
      "fip": 16001,
      "county_name": "Ada",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16003,
      "county_name": "Adams",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16005,
      "county_name": "Bannock",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16007,
      "county_name": "Bear Lake",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16009,
      "county_name": "Benewah",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16011,
      "county_name": "Bingham",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16013,
      "county_name": "Blaine",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16015,
      "county_name": "Boise",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16017,
      "county_name": "Bonner",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16019,
      "county_name": "Bonneville",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16021,
      "county_name": "Boundary",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16023,
      "county_name": "Butte",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16025,
      "county_name": "Camas",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16027,
      "county_name": "Canyon",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16029,
      "county_name": "Caribou",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16031,
      "county_name": "Cassia",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16033,
      "county_name": "Clark",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16035,
      "county_name": "Clearwater",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16037,
      "county_name": "Custer",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16039,
      "county_name": "Elmore",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16041,
      "county_name": "Franklin",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16043,
      "county_name": "Fremont",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16045,
      "county_name": "Gem",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16047,
      "county_name": "Gooding",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16049,
      "county_name": "Idaho",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16051,
      "county_name": "Jefferson",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16053,
      "county_name": "Jerome",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16055,
      "county_name": "Kootenai",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16057,
      "county_name": "Latah",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16059,
      "county_name": "Lemhi",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16061,
      "county_name": "Lewis",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16063,
      "county_name": "Lincoln",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16065,
      "county_name": "Madison",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16067,
      "county_name": "Minidoka",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16069,
      "county_name": "Nez Perce",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16071,
      "county_name": "Oneida",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16073,
      "county_name": "Owyhee",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16075,
      "county_name": "Payette",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16077,
      "county_name": "Power",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16079,
      "county_name": "Shoshone",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16081,
      "county_name": "Teton",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16083,
      "county_name": "Twin Falls",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16085,
      "county_name": "Valley",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 16087,
      "county_name": "Washington",
      "state": "ID",
      "state_name": "Idaho"
    },
    {
      "fip": 17001,
      "county_name": "Adams",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17003,
      "county_name": "Alexander",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17005,
      "county_name": "Bond",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17007,
      "county_name": "Boone",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17009,
      "county_name": "Brown",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17011,
      "county_name": "Bureau",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17013,
      "county_name": "Calhoun",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17015,
      "county_name": "Carroll",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17017,
      "county_name": "Cass",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17019,
      "county_name": "Champaign",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17021,
      "county_name": "Christian",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17023,
      "county_name": "Clark",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17025,
      "county_name": "Clay",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17027,
      "county_name": "Clinton",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17029,
      "county_name": "Coles",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17031,
      "county_name": "Cook",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17033,
      "county_name": "Crawford",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17035,
      "county_name": "Cumberland",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17037,
      "county_name": "DeKalb",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17039,
      "county_name": "De Witt",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17041,
      "county_name": "Douglas",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17043,
      "county_name": "DuPage",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17045,
      "county_name": "Edgar",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17047,
      "county_name": "Edwards",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17049,
      "county_name": "Effingham",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17051,
      "county_name": "Fayette",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17053,
      "county_name": "Ford",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17055,
      "county_name": "Franklin",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17057,
      "county_name": "Fulton",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17059,
      "county_name": "Gallatin",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17061,
      "county_name": "Greene",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17063,
      "county_name": "Grundy",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17065,
      "county_name": "Hamilton",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17067,
      "county_name": "Hancock",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17069,
      "county_name": "Hardin",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17071,
      "county_name": "Henderson",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17073,
      "county_name": "Henry",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17075,
      "county_name": "Iroquois",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17077,
      "county_name": "Jackson",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17079,
      "county_name": "Jasper",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17081,
      "county_name": "Jefferson",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17083,
      "county_name": "Jersey",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17085,
      "county_name": "Jo Daviess",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17087,
      "county_name": "Johnson",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17089,
      "county_name": "Kane",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17091,
      "county_name": "Kankakee",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17093,
      "county_name": "Kendall",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17095,
      "county_name": "Knox",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17097,
      "county_name": "Lake",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17099,
      "county_name": "LaSalle",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17101,
      "county_name": "Lawrence",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17103,
      "county_name": "Lee",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17105,
      "county_name": "Livingston",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17107,
      "county_name": "Logan",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17109,
      "county_name": "McDonough",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17111,
      "county_name": "McHenry",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17113,
      "county_name": "McLean",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17115,
      "county_name": "Macon",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17117,
      "county_name": "Macoupin",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17119,
      "county_name": "Madison",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17121,
      "county_name": "Marion",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17123,
      "county_name": "Marshall",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17125,
      "county_name": "Mason",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17127,
      "county_name": "Massac",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17129,
      "county_name": "Menard",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17131,
      "county_name": "Mercer",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17133,
      "county_name": "Monroe",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17135,
      "county_name": "Montgomery",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17137,
      "county_name": "Morgan",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17139,
      "county_name": "Moultrie",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17141,
      "county_name": "Ogle",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17143,
      "county_name": "Peoria",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17145,
      "county_name": "Perry",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17147,
      "county_name": "Piatt",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17149,
      "county_name": "Pike",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17151,
      "county_name": "Pope",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17153,
      "county_name": "Pulaski",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17155,
      "county_name": "Putnam",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17157,
      "county_name": "Randolph",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17159,
      "county_name": "Richland",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17161,
      "county_name": "Rock Island",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17163,
      "county_name": "St. Clair",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17165,
      "county_name": "Saline",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17167,
      "county_name": "Sangamon",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17169,
      "county_name": "Schuyler",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17171,
      "county_name": "Scott",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17173,
      "county_name": "Shelby",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17175,
      "county_name": "Stark",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17177,
      "county_name": "Stephenson",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17179,
      "county_name": "Tazewell",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17181,
      "county_name": "Union",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17183,
      "county_name": "Vermilion",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17185,
      "county_name": "Wabash",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17187,
      "county_name": "Warren",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17189,
      "county_name": "Washington",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17191,
      "county_name": "Wayne",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17193,
      "county_name": "White",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17195,
      "county_name": "Whiteside",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17197,
      "county_name": "Will",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17199,
      "county_name": "Williamson",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17201,
      "county_name": "Winnebago",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 17203,
      "county_name": "Woodford",
      "state": "IL",
      "state_name": "Illinois"
    },
    {
      "fip": 18001,
      "county_name": "Adams",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18003,
      "county_name": "Allen",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18005,
      "county_name": "Bartholomew",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18007,
      "county_name": "Benton",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18009,
      "county_name": "Blackford",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18011,
      "county_name": "Boone",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18013,
      "county_name": "Brown",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18015,
      "county_name": "Carroll",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18017,
      "county_name": "Cass",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18019,
      "county_name": "Clark",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18021,
      "county_name": "Clay",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18023,
      "county_name": "Clinton",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18025,
      "county_name": "Crawford",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18027,
      "county_name": "Daviess",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18029,
      "county_name": "Dearborn",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18031,
      "county_name": "Decatur",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18033,
      "county_name": "DeKalb",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18035,
      "county_name": "Delaware",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18037,
      "county_name": "Dubois",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18039,
      "county_name": "Elkhart",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18041,
      "county_name": "Fayette",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18043,
      "county_name": "Floyd",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18045,
      "county_name": "Fountain",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18047,
      "county_name": "Franklin",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18049,
      "county_name": "Fulton",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18051,
      "county_name": "Gibson",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18053,
      "county_name": "Grant",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18055,
      "county_name": "Greene",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18057,
      "county_name": "Hamilton",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18059,
      "county_name": "Hancock",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18061,
      "county_name": "Harrison",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18063,
      "county_name": "Hendricks",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18065,
      "county_name": "Henry",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18067,
      "county_name": "Howard",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18069,
      "county_name": "Huntington",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18071,
      "county_name": "Jackson",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18073,
      "county_name": "Jasper",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18075,
      "county_name": "Jay",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18077,
      "county_name": "Jefferson",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18079,
      "county_name": "Jennings",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18081,
      "county_name": "Johnson",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18083,
      "county_name": "Knox",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18085,
      "county_name": "Kosciusko",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18087,
      "county_name": "LaGrange",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18089,
      "county_name": "Lake",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18091,
      "county_name": "LaPorte",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18093,
      "county_name": "Lawrence",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18095,
      "county_name": "Madison",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18097,
      "county_name": "Marion",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18099,
      "county_name": "Marshall",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18101,
      "county_name": "Martin",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18103,
      "county_name": "Miami",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18105,
      "county_name": "Monroe",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18107,
      "county_name": "Montgomery",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18109,
      "county_name": "Morgan",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18111,
      "county_name": "Newton",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18113,
      "county_name": "Noble",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18115,
      "county_name": "Ohio",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18117,
      "county_name": "Orange",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18119,
      "county_name": "Owen",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18121,
      "county_name": "Parke",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18123,
      "county_name": "Perry",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18125,
      "county_name": "Pike",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18127,
      "county_name": "Porter",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18129,
      "county_name": "Posey",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18131,
      "county_name": "Pulaski",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18133,
      "county_name": "Putnam",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18135,
      "county_name": "Randolph",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18137,
      "county_name": "Ripley",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18139,
      "county_name": "Rush",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18141,
      "county_name": "St. Joseph",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18143,
      "county_name": "Scott",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18145,
      "county_name": "Shelby",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18147,
      "county_name": "Spencer",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18149,
      "county_name": "Starke",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18151,
      "county_name": "Steuben",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18153,
      "county_name": "Sullivan",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18155,
      "county_name": "Switzerland",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18157,
      "county_name": "Tippecanoe",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18159,
      "county_name": "Tipton",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18161,
      "county_name": "Union",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18163,
      "county_name": "Vanderburgh",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18165,
      "county_name": "Vermillion",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18167,
      "county_name": "Vigo",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18169,
      "county_name": "Wabash",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18171,
      "county_name": "Warren",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18173,
      "county_name": "Warrick",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18175,
      "county_name": "Washington",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18177,
      "county_name": "Wayne",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18179,
      "county_name": "Wells",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18181,
      "county_name": "White",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 18183,
      "county_name": "Whitley",
      "state": "IN",
      "state_name": "Indiana"
    },
    {
      "fip": 19001,
      "county_name": "Adair",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19003,
      "county_name": "Adams",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19005,
      "county_name": "Allamakee",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19007,
      "county_name": "Appanoose",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19009,
      "county_name": "Audubon",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19011,
      "county_name": "Benton",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19013,
      "county_name": "Black Hawk",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19015,
      "county_name": "Boone",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19017,
      "county_name": "Bremer",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19019,
      "county_name": "Buchanan",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19021,
      "county_name": "Buena Vista",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19023,
      "county_name": "Butler",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19025,
      "county_name": "Calhoun",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19027,
      "county_name": "Carroll",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19029,
      "county_name": "Cass",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19031,
      "county_name": "Cedar",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19033,
      "county_name": "Cerro Gordo",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19035,
      "county_name": "Cherokee",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19037,
      "county_name": "Chickasaw",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19039,
      "county_name": "Clarke",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19041,
      "county_name": "Clay",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19043,
      "county_name": "Clayton",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19045,
      "county_name": "Clinton",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19047,
      "county_name": "Crawford",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19049,
      "county_name": "Dallas",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19051,
      "county_name": "Davis",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19053,
      "county_name": "Decatur",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19055,
      "county_name": "Delaware",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19057,
      "county_name": "Des Moines",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19059,
      "county_name": "Dickinson",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19061,
      "county_name": "Dubuque",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19063,
      "county_name": "Emmet",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19065,
      "county_name": "Fayette",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19067,
      "county_name": "Floyd",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19069,
      "county_name": "Franklin",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19071,
      "county_name": "Fremont",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19073,
      "county_name": "Greene",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19075,
      "county_name": "Grundy",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19077,
      "county_name": "Guthrie",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19079,
      "county_name": "Hamilton",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19081,
      "county_name": "Hancock",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19083,
      "county_name": "Hardin",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19085,
      "county_name": "Harrison",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19087,
      "county_name": "Henry",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19089,
      "county_name": "Howard",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19091,
      "county_name": "Humboldt",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19093,
      "county_name": "Ida",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19095,
      "county_name": "Iowa",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19097,
      "county_name": "Jackson",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19099,
      "county_name": "Jasper",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19101,
      "county_name": "Jefferson",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19103,
      "county_name": "Johnson",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19105,
      "county_name": "Jones",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19107,
      "county_name": "Keokuk",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19109,
      "county_name": "Kossuth",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19111,
      "county_name": "Lee",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19113,
      "county_name": "Linn",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19115,
      "county_name": "Louisa",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19117,
      "county_name": "Lucas",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19119,
      "county_name": "Lyon",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19121,
      "county_name": "Madison",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19123,
      "county_name": "Mahaska",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19125,
      "county_name": "Marion",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19127,
      "county_name": "Marshall",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19129,
      "county_name": "Mills",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19131,
      "county_name": "Mitchell",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19133,
      "county_name": "Monona",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19135,
      "county_name": "Monroe",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19137,
      "county_name": "Montgomery",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19139,
      "county_name": "Muscatine",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19141,
      "county_name": "O'Brien",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19143,
      "county_name": "Osceola",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19145,
      "county_name": "Page",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19147,
      "county_name": "Palo Alto",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19149,
      "county_name": "Plymouth",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19151,
      "county_name": "Pocahontas",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19153,
      "county_name": "Polk",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19155,
      "county_name": "Pottawattamie",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19157,
      "county_name": "Poweshiek",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19159,
      "county_name": "Ringgold",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19161,
      "county_name": "Sac",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19163,
      "county_name": "Scott",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19165,
      "county_name": "Shelby",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19167,
      "county_name": "Sioux",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19169,
      "county_name": "Story",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19171,
      "county_name": "Tama",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19173,
      "county_name": "Taylor",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19175,
      "county_name": "Union",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19177,
      "county_name": "Van Buren",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19179,
      "county_name": "Wapello",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19181,
      "county_name": "Warren",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19183,
      "county_name": "Washington",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19185,
      "county_name": "Wayne",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19187,
      "county_name": "Webster",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19189,
      "county_name": "Winnebago",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19191,
      "county_name": "Winneshiek",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19193,
      "county_name": "Woodbury",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19195,
      "county_name": "Worth",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 19197,
      "county_name": "Wright",
      "state": "IA",
      "state_name": "Iowa"
    },
    {
      "fip": 20001,
      "county_name": "Allen",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20003,
      "county_name": "Anderson",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20005,
      "county_name": "Atchison",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20007,
      "county_name": "Barber",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20009,
      "county_name": "Barton",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20011,
      "county_name": "Bourbon",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20013,
      "county_name": "Brown",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20015,
      "county_name": "Butler",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20017,
      "county_name": "Chase",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20019,
      "county_name": "Chautauqua",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20021,
      "county_name": "Cherokee",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20023,
      "county_name": "Cheyenne",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20025,
      "county_name": "Clark",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20027,
      "county_name": "Clay",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20029,
      "county_name": "Cloud",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20031,
      "county_name": "Coffey",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20033,
      "county_name": "Comanche",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20035,
      "county_name": "Cowley",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20037,
      "county_name": "Crawford",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20039,
      "county_name": "Decatur",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20041,
      "county_name": "Dickinson",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20043,
      "county_name": "Doniphan",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20045,
      "county_name": "Douglas",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20047,
      "county_name": "Edwards",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20049,
      "county_name": "Elk",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20051,
      "county_name": "Ellis",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20053,
      "county_name": "Ellsworth",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20055,
      "county_name": "Finney",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20057,
      "county_name": "Ford",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20059,
      "county_name": "Franklin",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20061,
      "county_name": "Geary",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20063,
      "county_name": "Gove",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20065,
      "county_name": "Graham",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20067,
      "county_name": "Grant",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20069,
      "county_name": "Gray",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20071,
      "county_name": "Greeley",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20073,
      "county_name": "Greenwood",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20075,
      "county_name": "Hamilton",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20077,
      "county_name": "Harper",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20079,
      "county_name": "Harvey",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20081,
      "county_name": "Haskell",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20083,
      "county_name": "Hodgeman",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20085,
      "county_name": "Jackson",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20087,
      "county_name": "Jefferson",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20089,
      "county_name": "Jewell",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20091,
      "county_name": "Johnson",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20093,
      "county_name": "Kearny",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20095,
      "county_name": "Kingman",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20097,
      "county_name": "Kiowa",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20099,
      "county_name": "Labette",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20101,
      "county_name": "Lane",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20103,
      "county_name": "Leavenworth",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20105,
      "county_name": "Lincoln",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20107,
      "county_name": "Linn",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20109,
      "county_name": "Logan",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20111,
      "county_name": "Lyon",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20113,
      "county_name": "McPherson",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20115,
      "county_name": "Marion",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20117,
      "county_name": "Marshall",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20119,
      "county_name": "Meade",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20121,
      "county_name": "Miami",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20123,
      "county_name": "Mitchell",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20125,
      "county_name": "Montgomery",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20127,
      "county_name": "Morris",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20129,
      "county_name": "Morton",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20131,
      "county_name": "Nemaha",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20133,
      "county_name": "Neosho",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20135,
      "county_name": "Ness",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20137,
      "county_name": "Norton",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20139,
      "county_name": "Osage",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20141,
      "county_name": "Osborne",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20143,
      "county_name": "Ottawa",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20145,
      "county_name": "Pawnee",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20147,
      "county_name": "Phillips",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20149,
      "county_name": "Pottawatomie",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20151,
      "county_name": "Pratt",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20153,
      "county_name": "Rawlins",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20155,
      "county_name": "Reno",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20157,
      "county_name": "Republic",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20159,
      "county_name": "Rice",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20161,
      "county_name": "Riley",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20163,
      "county_name": "Rooks",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20165,
      "county_name": "Rush",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20167,
      "county_name": "Russell",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20169,
      "county_name": "Saline",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20171,
      "county_name": "Scott",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20173,
      "county_name": "Sedgwick",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20175,
      "county_name": "Seward",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20177,
      "county_name": "Shawnee",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20179,
      "county_name": "Sheridan",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20181,
      "county_name": "Sherman",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20183,
      "county_name": "Smith",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20185,
      "county_name": "Stafford",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20187,
      "county_name": "Stanton",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20189,
      "county_name": "Stevens",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20191,
      "county_name": "Sumner",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20193,
      "county_name": "Thomas",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20195,
      "county_name": "Trego",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20197,
      "county_name": "Wabaunsee",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20199,
      "county_name": "Wallace",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20201,
      "county_name": "Washington",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20203,
      "county_name": "Wichita",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20205,
      "county_name": "Wilson",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20207,
      "county_name": "Woodson",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 20209,
      "county_name": "Wyandotte",
      "state": "KS",
      "state_name": "Kansas"
    },
    {
      "fip": 21001,
      "county_name": "Adair",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21003,
      "county_name": "Allen",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21005,
      "county_name": "Anderson",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21007,
      "county_name": "Ballard",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21009,
      "county_name": "Barren",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21011,
      "county_name": "Bath",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21013,
      "county_name": "Bell",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21015,
      "county_name": "Boone",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21017,
      "county_name": "Bourbon",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21019,
      "county_name": "Boyd",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21021,
      "county_name": "Boyle",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21023,
      "county_name": "Bracken",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21025,
      "county_name": "Breathitt",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21027,
      "county_name": "Breckinridge",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21029,
      "county_name": "Bullitt",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21031,
      "county_name": "Butler",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21033,
      "county_name": "Caldwell",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21035,
      "county_name": "Calloway",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21037,
      "county_name": "Campbell",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21039,
      "county_name": "Carlisle",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21041,
      "county_name": "Carroll",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21043,
      "county_name": "Carter",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21045,
      "county_name": "Casey",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21047,
      "county_name": "Christian",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21049,
      "county_name": "Clark",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21051,
      "county_name": "Clay",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21053,
      "county_name": "Clinton",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21055,
      "county_name": "Crittenden",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21057,
      "county_name": "Cumberland",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21059,
      "county_name": "Daviess",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21061,
      "county_name": "Edmonson",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21063,
      "county_name": "Elliott",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21065,
      "county_name": "Estill",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21067,
      "county_name": "Fayette",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21069,
      "county_name": "Fleming",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21071,
      "county_name": "Floyd",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21073,
      "county_name": "Franklin",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21075,
      "county_name": "Fulton",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21077,
      "county_name": "Gallatin",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21079,
      "county_name": "Garrard",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21081,
      "county_name": "Grant",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21083,
      "county_name": "Graves",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21085,
      "county_name": "Grayson",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21087,
      "county_name": "Green",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21089,
      "county_name": "Greenup",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21091,
      "county_name": "Hancock",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21093,
      "county_name": "Hardin",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21095,
      "county_name": "Harlan",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21097,
      "county_name": "Harrison",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21099,
      "county_name": "Hart",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21101,
      "county_name": "Henderson",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21103,
      "county_name": "Henry",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21105,
      "county_name": "Hickman",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21107,
      "county_name": "Hopkins",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21109,
      "county_name": "Jackson",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21111,
      "county_name": "Jefferson",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21113,
      "county_name": "Jessamine",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21115,
      "county_name": "Johnson",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21117,
      "county_name": "Kenton",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21119,
      "county_name": "Knott",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21121,
      "county_name": "Knox",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21123,
      "county_name": "Larue",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21125,
      "county_name": "Laurel",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21127,
      "county_name": "Lawrence",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21129,
      "county_name": "Lee",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21131,
      "county_name": "Leslie",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21133,
      "county_name": "Letcher",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21135,
      "county_name": "Lewis",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21137,
      "county_name": "Lincoln",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21139,
      "county_name": "Livingston",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21141,
      "county_name": "Logan",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21143,
      "county_name": "Lyon",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21145,
      "county_name": "McCracken",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21147,
      "county_name": "McCreary",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21149,
      "county_name": "McLean",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21151,
      "county_name": "Madison",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21153,
      "county_name": "Magoffin",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21155,
      "county_name": "Marion",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21157,
      "county_name": "Marshall",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21159,
      "county_name": "Martin",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21161,
      "county_name": "Mason",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21163,
      "county_name": "Meade",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21165,
      "county_name": "Menifee",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21167,
      "county_name": "Mercer",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21169,
      "county_name": "Metcalfe",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21171,
      "county_name": "Monroe",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21173,
      "county_name": "Montgomery",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21175,
      "county_name": "Morgan",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21177,
      "county_name": "Muhlenberg",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21179,
      "county_name": "Nelson",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21181,
      "county_name": "Nicholas",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21183,
      "county_name": "Ohio",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21185,
      "county_name": "Oldham",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21187,
      "county_name": "Owen",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21189,
      "county_name": "Owsley",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21191,
      "county_name": "Pendleton",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21193,
      "county_name": "Perry",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21195,
      "county_name": "Pike",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21197,
      "county_name": "Powell",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21199,
      "county_name": "Pulaski",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21201,
      "county_name": "Robertson",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21203,
      "county_name": "Rockcastle",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21205,
      "county_name": "Rowan",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21207,
      "county_name": "Russell",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21209,
      "county_name": "Scott",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21211,
      "county_name": "Shelby",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21213,
      "county_name": "Simpson",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21215,
      "county_name": "Spencer",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21217,
      "county_name": "Taylor",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21219,
      "county_name": "Todd",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21221,
      "county_name": "Trigg",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21223,
      "county_name": "Trimble",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21225,
      "county_name": "Union",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21227,
      "county_name": "Warren",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21229,
      "county_name": "Washington",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21231,
      "county_name": "Wayne",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21233,
      "county_name": "Webster",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21235,
      "county_name": "Whitley",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21237,
      "county_name": "Wolfe",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 21239,
      "county_name": "Woodford",
      "state": "KY",
      "state_name": "Kentucky"
    },
    {
      "fip": 22001,
      "county_name": "Acadia Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22003,
      "county_name": "Allen Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22005,
      "county_name": "Ascension Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22007,
      "county_name": "Assumption Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22009,
      "county_name": "Avoyelles Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22011,
      "county_name": "Beauregard Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22013,
      "county_name": "Bienville Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22015,
      "county_name": "Bossier Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22017,
      "county_name": "Caddo Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22019,
      "county_name": "Calcasieu Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22021,
      "county_name": "Caldwell Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22023,
      "county_name": "Cameron Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22025,
      "county_name": "Catahoula Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22027,
      "county_name": "Claiborne Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22029,
      "county_name": "Concordia Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22031,
      "county_name": "De Soto Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22033,
      "county_name": "East Baton Rouge Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22035,
      "county_name": "East Carroll Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22037,
      "county_name": "East Feliciana Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22039,
      "county_name": "Evangeline Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22041,
      "county_name": "Franklin Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22043,
      "county_name": "Grant Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22045,
      "county_name": "Iberia Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22047,
      "county_name": "Iberville Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22049,
      "county_name": "Jackson Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22051,
      "county_name": "Jefferson Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22053,
      "county_name": "Jefferson Davis Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22055,
      "county_name": "Lafayette Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22057,
      "county_name": "Lafourche Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22059,
      "county_name": "La Salle Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22061,
      "county_name": "Lincoln Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22063,
      "county_name": "Livingston Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22065,
      "county_name": "Madison Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22067,
      "county_name": "Morehouse Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22069,
      "county_name": "Natchitoches Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22071,
      "county_name": "Orleans Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22073,
      "county_name": "Ouachita Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22075,
      "county_name": "Plaquemines Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22077,
      "county_name": "Pointe Coupee Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22079,
      "county_name": "Rapides Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22081,
      "county_name": "Red River Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22083,
      "county_name": "Richland Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22085,
      "county_name": "Sabine Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22087,
      "county_name": "St. Bernard Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22089,
      "county_name": "St. Charles Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22091,
      "county_name": "St. Helena Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22093,
      "county_name": "St. James Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22095,
      "county_name": "St. John the Baptist Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22097,
      "county_name": "St. Landry Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22099,
      "county_name": "St. Martin Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22101,
      "county_name": "St. Mary Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22103,
      "county_name": "St. Tammany Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22105,
      "county_name": "Tangipahoa Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22107,
      "county_name": "Tensas Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22109,
      "county_name": "Terrebonne Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22111,
      "county_name": "Union Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22113,
      "county_name": "Vermilion Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22115,
      "county_name": "Vernon Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22117,
      "county_name": "Washington Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22119,
      "county_name": "Webster Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22121,
      "county_name": "West Baton Rouge Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22123,
      "county_name": "West Carroll Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22125,
      "county_name": "West Feliciana Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 22127,
      "county_name": "Winn Parish",
      "state": "LA",
      "state_name": "Louisiana"
    },
    {
      "fip": 23001,
      "county_name": "Androscoggin",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23003,
      "county_name": "Aroostook",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23005,
      "county_name": "Cumberland",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23007,
      "county_name": "Franklin",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23009,
      "county_name": "Hancock",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23011,
      "county_name": "Kennebec",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23013,
      "county_name": "Knox",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23015,
      "county_name": "Lincoln",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23017,
      "county_name": "Oxford",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23019,
      "county_name": "Penobscot",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23021,
      "county_name": "Piscataquis",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23023,
      "county_name": "Sagadahoc",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23025,
      "county_name": "Somerset",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23027,
      "county_name": "Waldo",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23029,
      "county_name": "Washington",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 23031,
      "county_name": "York",
      "state": "ME",
      "state_name": "Maine"
    },
    {
      "fip": 24001,
      "county_name": "Allegany",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24003,
      "county_name": "Anne Arundel",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24005,
      "county_name": "Baltimore",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24009,
      "county_name": "Calvert",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24011,
      "county_name": "Caroline",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24013,
      "county_name": "Carroll",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24015,
      "county_name": "Cecil",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24017,
      "county_name": "Charles",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24019,
      "county_name": "Dorchester",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24021,
      "county_name": "Frederick",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24023,
      "county_name": "Garrett",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24025,
      "county_name": "Harford",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24027,
      "county_name": "Howard",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24029,
      "county_name": "Kent",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24031,
      "county_name": "Montgomery",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24033,
      "county_name": "Prince George's",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24035,
      "county_name": "Queen Anne's",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24037,
      "county_name": "St. Mary's",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24039,
      "county_name": "Somerset",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24041,
      "county_name": "Talbot",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24043,
      "county_name": "Washington",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24045,
      "county_name": "Wicomico",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24047,
      "county_name": "Worcester",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 24510,
      "county_name": "Baltimore city",
      "state": "MD",
      "state_name": "Maryland"
    },
    {
      "fip": 25001,
      "county_name": "Barnstable",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25003,
      "county_name": "Berkshire",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25005,
      "county_name": "Bristol",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25007,
      "county_name": "Dukes",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25009,
      "county_name": "Essex",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25011,
      "county_name": "Franklin",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25013,
      "county_name": "Hampden",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25015,
      "county_name": "Hampshire",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25017,
      "county_name": "Middlesex",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25019,
      "county_name": "Nantucket",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25021,
      "county_name": "Norfolk",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25023,
      "county_name": "Plymouth",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25025,
      "county_name": "Suffolk",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 25027,
      "county_name": "Worcester",
      "state": "MA",
      "state_name": "Massachusetts"
    },
    {
      "fip": 26001,
      "county_name": "Alcona",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26003,
      "county_name": "Alger",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26005,
      "county_name": "Allegan",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26007,
      "county_name": "Alpena",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26009,
      "county_name": "Antrim",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26011,
      "county_name": "Arenac",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26013,
      "county_name": "Baraga",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26015,
      "county_name": "Barry",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26017,
      "county_name": "Bay",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26019,
      "county_name": "Benzie",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26021,
      "county_name": "Berrien",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26023,
      "county_name": "Branch",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26025,
      "county_name": "Calhoun",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26027,
      "county_name": "Cass",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26029,
      "county_name": "Charlevoix",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26031,
      "county_name": "Cheboygan",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26033,
      "county_name": "Chippewa",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26035,
      "county_name": "Clare",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26037,
      "county_name": "Clinton",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26039,
      "county_name": "Crawford",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26041,
      "county_name": "Delta",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26043,
      "county_name": "Dickinson",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26045,
      "county_name": "Eaton",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26047,
      "county_name": "Emmet",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26049,
      "county_name": "Genesee",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26051,
      "county_name": "Gladwin",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26053,
      "county_name": "Gogebic",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26055,
      "county_name": "Grand Traverse",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26057,
      "county_name": "Gratiot",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26059,
      "county_name": "Hillsdale",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26061,
      "county_name": "Houghton",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26063,
      "county_name": "Huron",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26065,
      "county_name": "Ingham",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26067,
      "county_name": "Ionia",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26069,
      "county_name": "Iosco",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26071,
      "county_name": "Iron",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26073,
      "county_name": "Isabella",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26075,
      "county_name": "Jackson",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26077,
      "county_name": "Kalamazoo",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26079,
      "county_name": "Kalkaska",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26081,
      "county_name": "Kent",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26083,
      "county_name": "Keweenaw",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26085,
      "county_name": "Lake",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26087,
      "county_name": "Lapeer",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26089,
      "county_name": "Leelanau",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26091,
      "county_name": "Lenawee",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26093,
      "county_name": "Livingston",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26095,
      "county_name": "Luce",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26097,
      "county_name": "Mackinac",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26099,
      "county_name": "Macomb",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26101,
      "county_name": "Manistee",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26103,
      "county_name": "Marquette",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26105,
      "county_name": "Mason",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26107,
      "county_name": "Mecosta",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26109,
      "county_name": "Menominee",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26111,
      "county_name": "Midland",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26113,
      "county_name": "Missaukee",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26115,
      "county_name": "Monroe",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26117,
      "county_name": "Montcalm",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26119,
      "county_name": "Montmorency",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26121,
      "county_name": "Muskegon",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26123,
      "county_name": "Newaygo",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26125,
      "county_name": "Oakland",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26127,
      "county_name": "Oceana",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26129,
      "county_name": "Ogemaw",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26131,
      "county_name": "Ontonagon",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26133,
      "county_name": "Osceola",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26135,
      "county_name": "Oscoda",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26137,
      "county_name": "Otsego",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26139,
      "county_name": "Ottawa",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26141,
      "county_name": "Presque Isle",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26143,
      "county_name": "Roscommon",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26145,
      "county_name": "Saginaw",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26147,
      "county_name": "St. Clair",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26149,
      "county_name": "St. Joseph",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26151,
      "county_name": "Sanilac",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26153,
      "county_name": "Schoolcraft",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26155,
      "county_name": "Shiawassee",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26157,
      "county_name": "Tuscola",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26159,
      "county_name": "Van Buren",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26161,
      "county_name": "Washtenaw",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26163,
      "county_name": "Wayne",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 26165,
      "county_name": "Wexford",
      "state": "MI",
      "state_name": "Michigan"
    },
    {
      "fip": 27001,
      "county_name": "Aitkin",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27003,
      "county_name": "Anoka",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27005,
      "county_name": "Becker",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27007,
      "county_name": "Beltrami",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27009,
      "county_name": "Benton",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27011,
      "county_name": "Big Stone",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27013,
      "county_name": "Blue Earth",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27015,
      "county_name": "Brown",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27017,
      "county_name": "Carlton",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27019,
      "county_name": "Carver",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27021,
      "county_name": "Cass",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27023,
      "county_name": "Chippewa",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27025,
      "county_name": "Chisago",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27027,
      "county_name": "Clay",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27029,
      "county_name": "Clearwater",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27031,
      "county_name": "Cook",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27033,
      "county_name": "Cottonwood",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27035,
      "county_name": "Crow Wing",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27037,
      "county_name": "Dakota",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27039,
      "county_name": "Dodge",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27041,
      "county_name": "Douglas",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27043,
      "county_name": "Faribault",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27045,
      "county_name": "Fillmore",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27047,
      "county_name": "Freeborn",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27049,
      "county_name": "Goodhue",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27051,
      "county_name": "Grant",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27053,
      "county_name": "Hennepin",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27055,
      "county_name": "Houston",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27057,
      "county_name": "Hubbard",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27059,
      "county_name": "Isanti",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27061,
      "county_name": "Itasca",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27063,
      "county_name": "Jackson",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27065,
      "county_name": "Kanabec",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27067,
      "county_name": "Kandiyohi",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27069,
      "county_name": "Kittson",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27071,
      "county_name": "Koochiching",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27073,
      "county_name": "Lac qui Parle",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27075,
      "county_name": "Lake",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27077,
      "county_name": "Lake of the Woods",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27079,
      "county_name": "Le Sueur",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27081,
      "county_name": "Lincoln",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27083,
      "county_name": "Lyon",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27085,
      "county_name": "McLeod",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27087,
      "county_name": "Mahnomen",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27089,
      "county_name": "Marshall",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27091,
      "county_name": "Martin",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27093,
      "county_name": "Meeker",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27095,
      "county_name": "Mille Lacs",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27097,
      "county_name": "Morrison",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27099,
      "county_name": "Mower",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27101,
      "county_name": "Murray",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27103,
      "county_name": "Nicollet",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27105,
      "county_name": "Nobles",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27107,
      "county_name": "Norman",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27109,
      "county_name": "Olmsted",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27111,
      "county_name": "Otter Tail",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27113,
      "county_name": "Pennington",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27115,
      "county_name": "Pine",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27117,
      "county_name": "Pipestone",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27119,
      "county_name": "Polk",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27121,
      "county_name": "Pope",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27123,
      "county_name": "Ramsey",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27125,
      "county_name": "Red Lake",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27127,
      "county_name": "Redwood",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27129,
      "county_name": "Renville",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27131,
      "county_name": "Rice",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27133,
      "county_name": "Rock",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27135,
      "county_name": "Roseau",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27137,
      "county_name": "St. Louis",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27139,
      "county_name": "Scott",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27141,
      "county_name": "Sherburne",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27143,
      "county_name": "Sibley",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27145,
      "county_name": "Stearns",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27147,
      "county_name": "Steele",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27149,
      "county_name": "Stevens",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27151,
      "county_name": "Swift",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27153,
      "county_name": "Todd",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27155,
      "county_name": "Traverse",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27157,
      "county_name": "Wabasha",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27159,
      "county_name": "Wadena",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27161,
      "county_name": "Waseca",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27163,
      "county_name": "Washington",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27165,
      "county_name": "Watonwan",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27167,
      "county_name": "Wilkin",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27169,
      "county_name": "Winona",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27171,
      "county_name": "Wright",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 27173,
      "county_name": "Yellow Medicine",
      "state": "MN",
      "state_name": "Minnesota"
    },
    {
      "fip": 28001,
      "county_name": "Adams",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28003,
      "county_name": "Alcorn",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28005,
      "county_name": "Amite",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28007,
      "county_name": "Attala",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28009,
      "county_name": "Benton",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28011,
      "county_name": "Bolivar",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28013,
      "county_name": "Calhoun",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28015,
      "county_name": "Carroll",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28017,
      "county_name": "Chickasaw",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28019,
      "county_name": "Choctaw",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28021,
      "county_name": "Claiborne",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28023,
      "county_name": "Clarke",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28025,
      "county_name": "Clay",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28027,
      "county_name": "Coahoma",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28029,
      "county_name": "Copiah",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28031,
      "county_name": "Covington",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28033,
      "county_name": "DeSoto",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28035,
      "county_name": "Forrest",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28037,
      "county_name": "Franklin",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28039,
      "county_name": "George",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28041,
      "county_name": "Greene",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28043,
      "county_name": "Grenada",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28045,
      "county_name": "Hancock",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28047,
      "county_name": "Harrison",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28049,
      "county_name": "Hinds",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28051,
      "county_name": "Holmes",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28053,
      "county_name": "Humphreys",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28055,
      "county_name": "Issaquena",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28057,
      "county_name": "Itawamba",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28059,
      "county_name": "Jackson",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28061,
      "county_name": "Jasper",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28063,
      "county_name": "Jefferson",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28065,
      "county_name": "Jefferson Davis",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28067,
      "county_name": "Jones",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28069,
      "county_name": "Kemper",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28071,
      "county_name": "Lafayette",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28073,
      "county_name": "Lamar",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28075,
      "county_name": "Lauderdale",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28077,
      "county_name": "Lawrence",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28079,
      "county_name": "Leake",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28081,
      "county_name": "Lee",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28083,
      "county_name": "Leflore",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28085,
      "county_name": "Lincoln",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28087,
      "county_name": "Lowndes",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28089,
      "county_name": "Madison",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28091,
      "county_name": "Marion",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28093,
      "county_name": "Marshall",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28095,
      "county_name": "Monroe",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28097,
      "county_name": "Montgomery",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28099,
      "county_name": "Neshoba",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28101,
      "county_name": "Newton",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28103,
      "county_name": "Noxubee",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28105,
      "county_name": "Oktibbeha",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28107,
      "county_name": "Panola",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28109,
      "county_name": "Pearl River",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28111,
      "county_name": "Perry",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28113,
      "county_name": "Pike",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28115,
      "county_name": "Pontotoc",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28117,
      "county_name": "Prentiss",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28119,
      "county_name": "Quitman",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28121,
      "county_name": "Rankin",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28123,
      "county_name": "Scott",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28125,
      "county_name": "Sharkey",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28127,
      "county_name": "Simpson",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28129,
      "county_name": "Smith",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28131,
      "county_name": "Stone",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28133,
      "county_name": "Sunflower",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28135,
      "county_name": "Tallahatchie",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28137,
      "county_name": "Tate",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28139,
      "county_name": "Tippah",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28141,
      "county_name": "Tishomingo",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28143,
      "county_name": "Tunica",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28145,
      "county_name": "Union",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28147,
      "county_name": "Walthall",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28149,
      "county_name": "Warren",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28151,
      "county_name": "Washington",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28153,
      "county_name": "Wayne",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28155,
      "county_name": "Webster",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28157,
      "county_name": "Wilkinson",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28159,
      "county_name": "Winston",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28161,
      "county_name": "Yalobusha",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 28163,
      "county_name": "Yazoo",
      "state": "MS",
      "state_name": "Mississippi"
    },
    {
      "fip": 29001,
      "county_name": "Adair",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29003,
      "county_name": "Andrew",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29005,
      "county_name": "Atchison",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29007,
      "county_name": "Audrain",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29009,
      "county_name": "Barry",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29011,
      "county_name": "Barton",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29013,
      "county_name": "Bates",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29015,
      "county_name": "Benton",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29017,
      "county_name": "Bollinger",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29019,
      "county_name": "Boone",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29021,
      "county_name": "Buchanan",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29023,
      "county_name": "Butler",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29025,
      "county_name": "Caldwell",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29027,
      "county_name": "Callaway",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29029,
      "county_name": "Camden",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29031,
      "county_name": "Cape Girardeau",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29033,
      "county_name": "Carroll",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29035,
      "county_name": "Carter",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29037,
      "county_name": "Cass",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29039,
      "county_name": "Cedar",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29041,
      "county_name": "Chariton",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29043,
      "county_name": "Christian",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29045,
      "county_name": "Clark",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29047,
      "county_name": "Clay",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29049,
      "county_name": "Clinton",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29051,
      "county_name": "Cole",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29053,
      "county_name": "Cooper",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29055,
      "county_name": "Crawford",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29057,
      "county_name": "Dade",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29059,
      "county_name": "Dallas",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29061,
      "county_name": "Daviess",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29063,
      "county_name": "DeKalb",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29065,
      "county_name": "Dent",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29067,
      "county_name": "Douglas",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29069,
      "county_name": "Dunklin",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29071,
      "county_name": "Franklin",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29073,
      "county_name": "Gasconade",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29075,
      "county_name": "Gentry",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29077,
      "county_name": "Greene",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29079,
      "county_name": "Grundy",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29081,
      "county_name": "Harrison",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29083,
      "county_name": "Henry",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29085,
      "county_name": "Hickory",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29087,
      "county_name": "Holt",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29089,
      "county_name": "Howard",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29091,
      "county_name": "Howell",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29093,
      "county_name": "Iron",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29095,
      "county_name": "Jackson",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29097,
      "county_name": "Jasper",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29099,
      "county_name": "Jefferson",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29101,
      "county_name": "Johnson",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29103,
      "county_name": "Knox",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29105,
      "county_name": "Laclede",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29107,
      "county_name": "Lafayette",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29109,
      "county_name": "Lawrence",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29111,
      "county_name": "Lewis",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29113,
      "county_name": "Lincoln",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29115,
      "county_name": "Linn",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29117,
      "county_name": "Livingston",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29119,
      "county_name": "McDonald",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29121,
      "county_name": "Macon",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29123,
      "county_name": "Madison",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29125,
      "county_name": "Maries",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29127,
      "county_name": "Marion",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29129,
      "county_name": "Mercer",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29131,
      "county_name": "Miller",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29133,
      "county_name": "Mississippi",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29135,
      "county_name": "Moniteau",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29137,
      "county_name": "Monroe",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29139,
      "county_name": "Montgomery",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29141,
      "county_name": "Morgan",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29143,
      "county_name": "New Madrid",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29145,
      "county_name": "Newton",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29147,
      "county_name": "Nodaway",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29149,
      "county_name": "Oregon",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29151,
      "county_name": "Osage",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29153,
      "county_name": "Ozark",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29155,
      "county_name": "Pemiscot",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29157,
      "county_name": "Perry",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29159,
      "county_name": "Pettis",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29161,
      "county_name": "Phelps",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29163,
      "county_name": "Pike",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29165,
      "county_name": "Platte",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29167,
      "county_name": "Polk",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29169,
      "county_name": "Pulaski",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29171,
      "county_name": "Putnam",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29173,
      "county_name": "Ralls",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29175,
      "county_name": "Randolph",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29177,
      "county_name": "Ray",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29179,
      "county_name": "Reynolds",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29181,
      "county_name": "Ripley",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29183,
      "county_name": "St. Charles",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29185,
      "county_name": "St. Clair",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29186,
      "county_name": "Ste. Genevieve",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29187,
      "county_name": "St. Francois",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29189,
      "county_name": "St. Louis",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29195,
      "county_name": "Saline",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29197,
      "county_name": "Schuyler",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29199,
      "county_name": "Scotland",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29201,
      "county_name": "Scott",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29203,
      "county_name": "Shannon",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29205,
      "county_name": "Shelby",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29207,
      "county_name": "Stoddard",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29209,
      "county_name": "Stone",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29211,
      "county_name": "Sullivan",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29213,
      "county_name": "Taney",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29215,
      "county_name": "Texas",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29217,
      "county_name": "Vernon",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29219,
      "county_name": "Warren",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29221,
      "county_name": "Washington",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29223,
      "county_name": "Wayne",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29225,
      "county_name": "Webster",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29227,
      "county_name": "Worth",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29229,
      "county_name": "Wright",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 29510,
      "county_name": "St. Louis city",
      "state": "MO",
      "state_name": "Missouri"
    },
    {
      "fip": 30001,
      "county_name": "Beaverhead",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30003,
      "county_name": "Big Horn",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30005,
      "county_name": "Blaine",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30007,
      "county_name": "Broadwater",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30009,
      "county_name": "Carbon",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30011,
      "county_name": "Carter",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30013,
      "county_name": "Cascade",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30015,
      "county_name": "Chouteau",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30017,
      "county_name": "Custer",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30019,
      "county_name": "Daniels",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30021,
      "county_name": "Dawson",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30023,
      "county_name": "Deer Lodge",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30025,
      "county_name": "Fallon",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30027,
      "county_name": "Fergus",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30029,
      "county_name": "Flathead",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30031,
      "county_name": "Gallatin",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30033,
      "county_name": "Garfield",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30035,
      "county_name": "Glacier",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30037,
      "county_name": "Golden Valley",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30039,
      "county_name": "Granite",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30041,
      "county_name": "Hill",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30043,
      "county_name": "Jefferson",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30045,
      "county_name": "Judith Basin",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30047,
      "county_name": "Lake",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30049,
      "county_name": "Lewis and Clark",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30051,
      "county_name": "Liberty",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30053,
      "county_name": "Lincoln",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30055,
      "county_name": "McCone",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30057,
      "county_name": "Madison",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30059,
      "county_name": "Meagher",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30061,
      "county_name": "Mineral",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30063,
      "county_name": "Missoula",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30065,
      "county_name": "Musselshell",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30067,
      "county_name": "Park",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30069,
      "county_name": "Petroleum",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30071,
      "county_name": "Phillips",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30073,
      "county_name": "Pondera",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30075,
      "county_name": "Powder River",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30077,
      "county_name": "Powell",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30079,
      "county_name": "Prairie",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30081,
      "county_name": "Ravalli",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30083,
      "county_name": "Richland",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30085,
      "county_name": "Roosevelt",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30087,
      "county_name": "Rosebud",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30089,
      "county_name": "Sanders",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30091,
      "county_name": "Sheridan",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30093,
      "county_name": "Silver Bow",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30095,
      "county_name": "Stillwater",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30097,
      "county_name": "Sweet Grass",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30099,
      "county_name": "Teton",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30101,
      "county_name": "Toole",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30103,
      "county_name": "Treasure",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30105,
      "county_name": "Valley",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30107,
      "county_name": "Wheatland",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30109,
      "county_name": "Wibaux",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 30111,
      "county_name": "Yellowstone",
      "state": "MT",
      "state_name": "Montana"
    },
    {
      "fip": 31001,
      "county_name": "Adams",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31003,
      "county_name": "Antelope",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31005,
      "county_name": "Arthur",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31007,
      "county_name": "Banner",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31009,
      "county_name": "Blaine",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31011,
      "county_name": "Boone",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31013,
      "county_name": "Box Butte",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31015,
      "county_name": "Boyd",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31017,
      "county_name": "Brown",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31019,
      "county_name": "Buffalo",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31021,
      "county_name": "Burt",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31023,
      "county_name": "Butler",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31025,
      "county_name": "Cass",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31027,
      "county_name": "Cedar",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31029,
      "county_name": "Chase",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31031,
      "county_name": "Cherry",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31033,
      "county_name": "Cheyenne",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31035,
      "county_name": "Clay",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31037,
      "county_name": "Colfax",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31039,
      "county_name": "Cuming",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31041,
      "county_name": "Custer",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31043,
      "county_name": "Dakota",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31045,
      "county_name": "Dawes",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31047,
      "county_name": "Dawson",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31049,
      "county_name": "Deuel",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31051,
      "county_name": "Dixon",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31053,
      "county_name": "Dodge",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31055,
      "county_name": "Douglas",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31057,
      "county_name": "Dundy",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31059,
      "county_name": "Fillmore",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31061,
      "county_name": "Franklin",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31063,
      "county_name": "Frontier",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31065,
      "county_name": "Furnas",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31067,
      "county_name": "Gage",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31069,
      "county_name": "Garden",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31071,
      "county_name": "Garfield",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31073,
      "county_name": "Gosper",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31075,
      "county_name": "Grant",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31077,
      "county_name": "Greeley",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31079,
      "county_name": "Hall",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31081,
      "county_name": "Hamilton",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31083,
      "county_name": "Harlan",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31085,
      "county_name": "Hayes",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31087,
      "county_name": "Hitchcock",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31089,
      "county_name": "Holt",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31091,
      "county_name": "Hooker",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31093,
      "county_name": "Howard",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31095,
      "county_name": "Jefferson",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31097,
      "county_name": "Johnson",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31099,
      "county_name": "Kearney",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31101,
      "county_name": "Keith",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31103,
      "county_name": "Keya Paha",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31105,
      "county_name": "Kimball",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31107,
      "county_name": "Knox",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31109,
      "county_name": "Lancaster",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31111,
      "county_name": "Lincoln",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31113,
      "county_name": "Logan",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31115,
      "county_name": "Loup",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31117,
      "county_name": "McPherson",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31119,
      "county_name": "Madison",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31121,
      "county_name": "Merrick",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31123,
      "county_name": "Morrill",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31125,
      "county_name": "Nance",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31127,
      "county_name": "Nemaha",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31129,
      "county_name": "Nuckolls",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31131,
      "county_name": "Otoe",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31133,
      "county_name": "Pawnee",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31135,
      "county_name": "Perkins",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31137,
      "county_name": "Phelps",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31139,
      "county_name": "Pierce",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31141,
      "county_name": "Platte",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31143,
      "county_name": "Polk",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31145,
      "county_name": "Red Willow",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31147,
      "county_name": "Richardson",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31149,
      "county_name": "Rock",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31151,
      "county_name": "Saline",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31153,
      "county_name": "Sarpy",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31155,
      "county_name": "Saunders",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31157,
      "county_name": "Scotts Bluff",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31159,
      "county_name": "Seward",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31161,
      "county_name": "Sheridan",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31163,
      "county_name": "Sherman",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31165,
      "county_name": "Sioux",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31167,
      "county_name": "Stanton",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31169,
      "county_name": "Thayer",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31171,
      "county_name": "Thomas",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31173,
      "county_name": "Thurston",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31175,
      "county_name": "Valley",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31177,
      "county_name": "Washington",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31179,
      "county_name": "Wayne",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31181,
      "county_name": "Webster",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31183,
      "county_name": "Wheeler",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 31185,
      "county_name": "York",
      "state": "NE",
      "state_name": "Nebraska"
    },
    {
      "fip": 32001,
      "county_name": "Churchill",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32003,
      "county_name": "Clark",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32005,
      "county_name": "Douglas",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32007,
      "county_name": "Elko",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32009,
      "county_name": "Esmeralda",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32011,
      "county_name": "Eureka",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32013,
      "county_name": "Humboldt",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32015,
      "county_name": "Lander",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32017,
      "county_name": "Lincoln",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32019,
      "county_name": "Lyon",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32021,
      "county_name": "Mineral",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32023,
      "county_name": "Nye",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32027,
      "county_name": "Pershing",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32029,
      "county_name": "Storey",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32031,
      "county_name": "Washoe",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32033,
      "county_name": "White Pine",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 32510,
      "county_name": "Carson City",
      "state": "NV",
      "state_name": "Nevada"
    },
    {
      "fip": 33001,
      "county_name": "Belknap",
      "state": "NH",
      "state_name": "New Hampshire"
    },
    {
      "fip": 33003,
      "county_name": "Carroll",
      "state": "NH",
      "state_name": "New Hampshire"
    },
    {
      "fip": 33005,
      "county_name": "Cheshire",
      "state": "NH",
      "state_name": "New Hampshire"
    },
    {
      "fip": 33007,
      "county_name": "Coos",
      "state": "NH",
      "state_name": "New Hampshire"
    },
    {
      "fip": 33009,
      "county_name": "Grafton",
      "state": "NH",
      "state_name": "New Hampshire"
    },
    {
      "fip": 33011,
      "county_name": "Hillsborough",
      "state": "NH",
      "state_name": "New Hampshire"
    },
    {
      "fip": 33013,
      "county_name": "Merrimack",
      "state": "NH",
      "state_name": "New Hampshire"
    },
    {
      "fip": 33015,
      "county_name": "Rockingham",
      "state": "NH",
      "state_name": "New Hampshire"
    },
    {
      "fip": 33017,
      "county_name": "Strafford",
      "state": "NH",
      "state_name": "New Hampshire"
    },
    {
      "fip": 33019,
      "county_name": "Sullivan",
      "state": "NH",
      "state_name": "New Hampshire"
    },
    {
      "fip": 34001,
      "county_name": "Atlantic",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34003,
      "county_name": "Bergen",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34005,
      "county_name": "Burlington",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34007,
      "county_name": "Camden",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34009,
      "county_name": "Cape May",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34011,
      "county_name": "Cumberland",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34013,
      "county_name": "Essex",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34015,
      "county_name": "Gloucester",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34017,
      "county_name": "Hudson",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34019,
      "county_name": "Hunterdon",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34021,
      "county_name": "Mercer",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34023,
      "county_name": "Middlesex",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34025,
      "county_name": "Monmouth",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34027,
      "county_name": "Morris",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34029,
      "county_name": "Ocean",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34031,
      "county_name": "Passaic",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34033,
      "county_name": "Salem",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34035,
      "county_name": "Somerset",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34037,
      "county_name": "Sussex",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34039,
      "county_name": "Union",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 34041,
      "county_name": "Warren",
      "state": "NJ",
      "state_name": "New Jersey"
    },
    {
      "fip": 35001,
      "county_name": "Bernalillo",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35003,
      "county_name": "Catron",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35005,
      "county_name": "Chaves",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35006,
      "county_name": "Cibola",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35007,
      "county_name": "Colfax",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35009,
      "county_name": "Curry",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35011,
      "county_name": "De Baca",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35013,
      "county_name": "Do�a Ana",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35015,
      "county_name": "Eddy",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35017,
      "county_name": "Grant",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35019,
      "county_name": "Guadalupe",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35021,
      "county_name": "Harding",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35023,
      "county_name": "Hidalgo",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35025,
      "county_name": "Lea",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35027,
      "county_name": "Lincoln",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35028,
      "county_name": "Los Alamos",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35029,
      "county_name": "Luna",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35031,
      "county_name": "McKinley",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35033,
      "county_name": "Mora",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35035,
      "county_name": "Otero",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35037,
      "county_name": "Quay",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35039,
      "county_name": "Rio Arriba",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35041,
      "county_name": "Roosevelt",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35043,
      "county_name": "Sandoval",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35045,
      "county_name": "San Juan",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35047,
      "county_name": "San Miguel",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35049,
      "county_name": "Santa Fe",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35051,
      "county_name": "Sierra",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35053,
      "county_name": "Socorro",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35055,
      "county_name": "Taos",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35057,
      "county_name": "Torrance",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35059,
      "county_name": "Union",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 35061,
      "county_name": "Valencia",
      "state": "NM",
      "state_name": "New Mexico"
    },
    {
      "fip": 36001,
      "county_name": "Albany",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36003,
      "county_name": "Allegany",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36005,
      "county_name": "Bronx",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36007,
      "county_name": "Broome",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36009,
      "county_name": "Cattaraugus",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36011,
      "county_name": "Cayuga",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36013,
      "county_name": "Chautauqua",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36015,
      "county_name": "Chemung",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36017,
      "county_name": "Chenango",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36019,
      "county_name": "Clinton",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36021,
      "county_name": "Columbia",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36023,
      "county_name": "Cortland",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36025,
      "county_name": "Delaware",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36027,
      "county_name": "Dutchess",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36029,
      "county_name": "Erie",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36031,
      "county_name": "Essex",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36033,
      "county_name": "Franklin",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36035,
      "county_name": "Fulton",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36037,
      "county_name": "Genesee",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36039,
      "county_name": "Greene",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36041,
      "county_name": "Hamilton",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36043,
      "county_name": "Herkimer",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36045,
      "county_name": "Jefferson",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36047,
      "county_name": "Kings",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36049,
      "county_name": "Lewis",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36051,
      "county_name": "Livingston",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36053,
      "county_name": "Madison",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36055,
      "county_name": "Monroe",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36057,
      "county_name": "Montgomery",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36059,
      "county_name": "Nassau",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36061,
      "county_name": "New York",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36063,
      "county_name": "Niagara",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36065,
      "county_name": "Oneida",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36067,
      "county_name": "Onondaga",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36069,
      "county_name": "Ontario",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36071,
      "county_name": "Orange",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36073,
      "county_name": "Orleans",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36075,
      "county_name": "Oswego",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36077,
      "county_name": "Otsego",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36079,
      "county_name": "Putnam",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36081,
      "county_name": "Queens",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36083,
      "county_name": "Rensselaer",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36085,
      "county_name": "Richmond",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36087,
      "county_name": "Rockland",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36089,
      "county_name": "St. Lawrence",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36091,
      "county_name": "Saratoga",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36093,
      "county_name": "Schenectady",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36095,
      "county_name": "Schoharie",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36097,
      "county_name": "Schuyler",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36099,
      "county_name": "Seneca",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36101,
      "county_name": "Steuben",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36103,
      "county_name": "Suffolk",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36105,
      "county_name": "Sullivan",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36107,
      "county_name": "Tioga",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36109,
      "county_name": "Tompkins",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36111,
      "county_name": "Ulster",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36113,
      "county_name": "Warren",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36115,
      "county_name": "Washington",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36117,
      "county_name": "Wayne",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36119,
      "county_name": "Westchester",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36121,
      "county_name": "Wyoming",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 36123,
      "county_name": "Yates",
      "state": "NY",
      "state_name": "New York"
    },
    {
      "fip": 37001,
      "county_name": "Alamance",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37003,
      "county_name": "Alexander",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37005,
      "county_name": "Alleghany",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37007,
      "county_name": "Anson",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37009,
      "county_name": "Ashe",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37011,
      "county_name": "Avery",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37013,
      "county_name": "Beaufort",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37015,
      "county_name": "Bertie",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37017,
      "county_name": "Bladen",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37019,
      "county_name": "Brunswick",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37021,
      "county_name": "Buncombe",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37023,
      "county_name": "Burke",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37025,
      "county_name": "Cabarrus",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37027,
      "county_name": "Caldwell",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37029,
      "county_name": "Camden",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37031,
      "county_name": "Carteret",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37033,
      "county_name": "Caswell",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37035,
      "county_name": "Catawba",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37037,
      "county_name": "Chatham",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37039,
      "county_name": "Cherokee",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37041,
      "county_name": "Chowan",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37043,
      "county_name": "Clay",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37045,
      "county_name": "Cleveland",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37047,
      "county_name": "Columbus",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37049,
      "county_name": "Craven",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37051,
      "county_name": "Cumberland",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37053,
      "county_name": "Currituck",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37055,
      "county_name": "Dare",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37057,
      "county_name": "Davidson",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37059,
      "county_name": "Davie",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37061,
      "county_name": "Duplin",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37063,
      "county_name": "Durham",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37065,
      "county_name": "Edgecombe",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37067,
      "county_name": "Forsyth",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37069,
      "county_name": "Franklin",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37071,
      "county_name": "Gaston",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37073,
      "county_name": "Gates",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37075,
      "county_name": "Graham",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37077,
      "county_name": "Granville",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37079,
      "county_name": "Greene",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37081,
      "county_name": "Guilford",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37083,
      "county_name": "Halifax",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37085,
      "county_name": "Harnett",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37087,
      "county_name": "Haywood",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37089,
      "county_name": "Henderson",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37091,
      "county_name": "Hertford",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37093,
      "county_name": "Hoke",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37095,
      "county_name": "Hyde",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37097,
      "county_name": "Iredell",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37099,
      "county_name": "Jackson",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37101,
      "county_name": "Johnston",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37103,
      "county_name": "Jones",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37105,
      "county_name": "Lee",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37107,
      "county_name": "Lenoir",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37109,
      "county_name": "Lincoln",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37111,
      "county_name": "McDowell",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37113,
      "county_name": "Macon",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37115,
      "county_name": "Madison",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37117,
      "county_name": "Martin",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37119,
      "county_name": "Mecklenburg",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37121,
      "county_name": "Mitchell",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37123,
      "county_name": "Montgomery",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37125,
      "county_name": "Moore",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37127,
      "county_name": "Nash",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37129,
      "county_name": "New Hanover",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37131,
      "county_name": "Northampton",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37133,
      "county_name": "Onslow",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37135,
      "county_name": "Orange",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37137,
      "county_name": "Pamlico",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37139,
      "county_name": "Pasquotank",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37141,
      "county_name": "Pender",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37143,
      "county_name": "Perquimans",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37145,
      "county_name": "Person",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37147,
      "county_name": "Pitt",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37149,
      "county_name": "Polk",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37151,
      "county_name": "Randolph",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37153,
      "county_name": "Richmond",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37155,
      "county_name": "Robeson",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37157,
      "county_name": "Rockingham",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37159,
      "county_name": "Rowan",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37161,
      "county_name": "Rutherford",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37163,
      "county_name": "Sampson",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37165,
      "county_name": "Scotland",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37167,
      "county_name": "Stanly",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37169,
      "county_name": "Stokes",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37171,
      "county_name": "Surry",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37173,
      "county_name": "Swain",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37175,
      "county_name": "Transylvania",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37177,
      "county_name": "Tyrrell",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37179,
      "county_name": "Union",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37181,
      "county_name": "Vance",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37183,
      "county_name": "Wake",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37185,
      "county_name": "Warren",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37187,
      "county_name": "Washington",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37189,
      "county_name": "Watauga",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37191,
      "county_name": "Wayne",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37193,
      "county_name": "Wilkes",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37195,
      "county_name": "Wilson",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37197,
      "county_name": "Yadkin",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 37199,
      "county_name": "Yancey",
      "state": "NC",
      "state_name": "North Carolina"
    },
    {
      "fip": 38001,
      "county_name": "Adams",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38003,
      "county_name": "Barnes",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38005,
      "county_name": "Benson",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38007,
      "county_name": "Billings",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38009,
      "county_name": "Bottineau",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38011,
      "county_name": "Bowman",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38013,
      "county_name": "Burke",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38015,
      "county_name": "Burleigh",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38017,
      "county_name": "Cass",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38019,
      "county_name": "Cavalier",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38021,
      "county_name": "Dickey",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38023,
      "county_name": "Divide",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38025,
      "county_name": "Dunn",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38027,
      "county_name": "Eddy",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38029,
      "county_name": "Emmons",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38031,
      "county_name": "Foster",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38033,
      "county_name": "Golden Valley",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38035,
      "county_name": "Grand Forks",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38037,
      "county_name": "Grant",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38039,
      "county_name": "Griggs",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38041,
      "county_name": "Hettinger",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38043,
      "county_name": "Kidder",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38045,
      "county_name": "LaMoure",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38047,
      "county_name": "Logan",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38049,
      "county_name": "McHenry",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38051,
      "county_name": "McIntosh",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38053,
      "county_name": "McKenzie",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38055,
      "county_name": "McLean",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38057,
      "county_name": "Mercer",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38059,
      "county_name": "Morton",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38061,
      "county_name": "Mountrail",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38063,
      "county_name": "Nelson",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38065,
      "county_name": "Oliver",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38067,
      "county_name": "Pembina",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38069,
      "county_name": "Pierce",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38071,
      "county_name": "Ramsey",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38073,
      "county_name": "Ransom",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38075,
      "county_name": "Renville",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38077,
      "county_name": "Richland",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38079,
      "county_name": "Rolette",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38081,
      "county_name": "Sargent",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38083,
      "county_name": "Sheridan",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38085,
      "county_name": "Sioux",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38087,
      "county_name": "Slope",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38089,
      "county_name": "Stark",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38091,
      "county_name": "Steele",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38093,
      "county_name": "Stutsman",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38095,
      "county_name": "Towner",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38097,
      "county_name": "Traill",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38099,
      "county_name": "Walsh",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38101,
      "county_name": "Ward",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38103,
      "county_name": "Wells",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 38105,
      "county_name": "Williams",
      "state": "ND",
      "state_name": "North Dakota"
    },
    {
      "fip": 39001,
      "county_name": "Adams",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39003,
      "county_name": "Allen",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39005,
      "county_name": "Ashland",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39007,
      "county_name": "Ashtabula",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39009,
      "county_name": "Athens",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39011,
      "county_name": "Auglaize",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39013,
      "county_name": "Belmont",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39015,
      "county_name": "Brown",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39017,
      "county_name": "Butler",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39019,
      "county_name": "Carroll",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39021,
      "county_name": "Champaign",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39023,
      "county_name": "Clark",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39025,
      "county_name": "Clermont",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39027,
      "county_name": "Clinton",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39029,
      "county_name": "Columbiana",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39031,
      "county_name": "Coshocton",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39033,
      "county_name": "Crawford",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39035,
      "county_name": "Cuyahoga",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39037,
      "county_name": "Darke",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39039,
      "county_name": "Defiance",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39041,
      "county_name": "Delaware",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39043,
      "county_name": "Erie",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39045,
      "county_name": "Fairfield",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39047,
      "county_name": "Fayette",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39049,
      "county_name": "Franklin",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39051,
      "county_name": "Fulton",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39053,
      "county_name": "Gallia",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39055,
      "county_name": "Geauga",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39057,
      "county_name": "Greene",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39059,
      "county_name": "Guernsey",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39061,
      "county_name": "Hamilton",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39063,
      "county_name": "Hancock",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39065,
      "county_name": "Hardin",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39067,
      "county_name": "Harrison",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39069,
      "county_name": "Henry",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39071,
      "county_name": "Highland",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39073,
      "county_name": "Hocking",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39075,
      "county_name": "Holmes",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39077,
      "county_name": "Huron",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39079,
      "county_name": "Jackson",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39081,
      "county_name": "Jefferson",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39083,
      "county_name": "Knox",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39085,
      "county_name": "Lake",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39087,
      "county_name": "Lawrence",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39089,
      "county_name": "Licking",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39091,
      "county_name": "Logan",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39093,
      "county_name": "Lorain",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39095,
      "county_name": "Lucas",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39097,
      "county_name": "Madison",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39099,
      "county_name": "Mahoning",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39101,
      "county_name": "Marion",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39103,
      "county_name": "Medina",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39105,
      "county_name": "Meigs",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39107,
      "county_name": "Mercer",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39109,
      "county_name": "Miami",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39111,
      "county_name": "Monroe",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39113,
      "county_name": "Montgomery",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39115,
      "county_name": "Morgan",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39117,
      "county_name": "Morrow",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39119,
      "county_name": "Muskingum",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39121,
      "county_name": "Noble",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39123,
      "county_name": "Ottawa",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39125,
      "county_name": "Paulding",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39127,
      "county_name": "Perry",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39129,
      "county_name": "Pickaway",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39131,
      "county_name": "Pike",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39133,
      "county_name": "Portage",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39135,
      "county_name": "Preble",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39137,
      "county_name": "Putnam",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39139,
      "county_name": "Richland",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39141,
      "county_name": "Ross",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39143,
      "county_name": "Sandusky",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39145,
      "county_name": "Scioto",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39147,
      "county_name": "Seneca",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39149,
      "county_name": "Shelby",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39151,
      "county_name": "Stark",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39153,
      "county_name": "Summit",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39155,
      "county_name": "Trumbull",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39157,
      "county_name": "Tuscarawas",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39159,
      "county_name": "Union",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39161,
      "county_name": "Van Wert",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39163,
      "county_name": "Vinton",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39165,
      "county_name": "Warren",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39167,
      "county_name": "Washington",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39169,
      "county_name": "Wayne",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39171,
      "county_name": "Williams",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39173,
      "county_name": "Wood",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 39175,
      "county_name": "Wyandot",
      "state": "OH",
      "state_name": "Ohio"
    },
    {
      "fip": 40001,
      "county_name": "Adair",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40003,
      "county_name": "Alfalfa",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40005,
      "county_name": "Atoka",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40007,
      "county_name": "Beaver",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40009,
      "county_name": "Beckham",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40011,
      "county_name": "Blaine",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40013,
      "county_name": "Bryan",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40015,
      "county_name": "Caddo",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40017,
      "county_name": "Canadian",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40019,
      "county_name": "Carter",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40021,
      "county_name": "Cherokee",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40023,
      "county_name": "Choctaw",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40025,
      "county_name": "Cimarron",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40027,
      "county_name": "Cleveland",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40029,
      "county_name": "Coal",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40031,
      "county_name": "Comanche",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40033,
      "county_name": "Cotton",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40035,
      "county_name": "Craig",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40037,
      "county_name": "Creek",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40039,
      "county_name": "Custer",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40041,
      "county_name": "Delaware",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40043,
      "county_name": "Dewey",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40045,
      "county_name": "Ellis",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40047,
      "county_name": "Garfield",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40049,
      "county_name": "Garvin",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40051,
      "county_name": "Grady",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40053,
      "county_name": "Grant",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40055,
      "county_name": "Greer",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40057,
      "county_name": "Harmon",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40059,
      "county_name": "Harper",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40061,
      "county_name": "Haskell",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40063,
      "county_name": "Hughes",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40065,
      "county_name": "Jackson",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40067,
      "county_name": "Jefferson",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40069,
      "county_name": "Johnston",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40071,
      "county_name": "Kay",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40073,
      "county_name": "Kingfisher",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40075,
      "county_name": "Kiowa",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40077,
      "county_name": "Latimer",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40079,
      "county_name": "Le Flore",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40081,
      "county_name": "Lincoln",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40083,
      "county_name": "Logan",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40085,
      "county_name": "Love",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40087,
      "county_name": "McClain",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40089,
      "county_name": "McCurtain",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40091,
      "county_name": "McIntosh",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40093,
      "county_name": "Major",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40095,
      "county_name": "Marshall",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40097,
      "county_name": "Mayes",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40099,
      "county_name": "Murray",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40101,
      "county_name": "Muskogee",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40103,
      "county_name": "Noble",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40105,
      "county_name": "Nowata",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40107,
      "county_name": "Okfuskee",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40109,
      "county_name": "Oklahoma",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40111,
      "county_name": "Okmulgee",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40113,
      "county_name": "Osage",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40115,
      "county_name": "Ottawa",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40117,
      "county_name": "Pawnee",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40119,
      "county_name": "Payne",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40121,
      "county_name": "Pittsburg",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40123,
      "county_name": "Pontotoc",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40125,
      "county_name": "Pottawatomie",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40127,
      "county_name": "Pushmataha",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40129,
      "county_name": "Roger Mills",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40131,
      "county_name": "Rogers",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40133,
      "county_name": "Seminole",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40135,
      "county_name": "Sequoyah",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40137,
      "county_name": "Stephens",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40139,
      "county_name": "Texas",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40141,
      "county_name": "Tillman",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40143,
      "county_name": "Tulsa",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40145,
      "county_name": "Wagoner",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40147,
      "county_name": "Washington",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40149,
      "county_name": "Washita",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40151,
      "county_name": "Woods",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 40153,
      "county_name": "Woodward",
      "state": "OK",
      "state_name": "Oklahoma"
    },
    {
      "fip": 41001,
      "county_name": "Baker",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41003,
      "county_name": "Benton",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41005,
      "county_name": "Clackamas",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41007,
      "county_name": "Clatsop",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41009,
      "county_name": "Columbia",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41011,
      "county_name": "Coos",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41013,
      "county_name": "Crook",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41015,
      "county_name": "Curry",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41017,
      "county_name": "Deschutes",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41019,
      "county_name": "Douglas",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41021,
      "county_name": "Gilliam",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41023,
      "county_name": "Grant",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41025,
      "county_name": "Harney",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41027,
      "county_name": "Hood River",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41029,
      "county_name": "Jackson",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41031,
      "county_name": "Jefferson",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41033,
      "county_name": "Josephine",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41035,
      "county_name": "Klamath",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41037,
      "county_name": "Lake",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41039,
      "county_name": "Lane",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41041,
      "county_name": "Lincoln",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41043,
      "county_name": "Linn",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41045,
      "county_name": "Malheur",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41047,
      "county_name": "Marion",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41049,
      "county_name": "Morrow",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41051,
      "county_name": "Multnomah",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41053,
      "county_name": "Polk",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41055,
      "county_name": "Sherman",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41057,
      "county_name": "Tillamook",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41059,
      "county_name": "Umatilla",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41061,
      "county_name": "Union",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41063,
      "county_name": "Wallowa",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41065,
      "county_name": "Wasco",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41067,
      "county_name": "Washington",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41069,
      "county_name": "Wheeler",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 41071,
      "county_name": "Yamhill",
      "state": "OR",
      "state_name": "Oregon"
    },
    {
      "fip": 42001,
      "county_name": "Adams",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42003,
      "county_name": "Allegheny",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42005,
      "county_name": "Armstrong",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42007,
      "county_name": "Beaver",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42009,
      "county_name": "Bedford",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42011,
      "county_name": "Berks",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42013,
      "county_name": "Blair",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42015,
      "county_name": "Bradford",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42017,
      "county_name": "Bucks",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42019,
      "county_name": "Butler",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42021,
      "county_name": "Cambria",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42023,
      "county_name": "Cameron",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42025,
      "county_name": "Carbon",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42027,
      "county_name": "Centre",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42029,
      "county_name": "Chester",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42031,
      "county_name": "Clarion",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42033,
      "county_name": "Clearfield",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42035,
      "county_name": "Clinton",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42037,
      "county_name": "Columbia",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42039,
      "county_name": "Crawford",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42041,
      "county_name": "Cumberland",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42043,
      "county_name": "Dauphin",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42045,
      "county_name": "Delaware",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42047,
      "county_name": "Elk",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42049,
      "county_name": "Erie",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42051,
      "county_name": "Fayette",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42053,
      "county_name": "Forest",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42055,
      "county_name": "Franklin",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42057,
      "county_name": "Fulton",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42059,
      "county_name": "Greene",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42061,
      "county_name": "Huntingdon",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42063,
      "county_name": "Indiana",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42065,
      "county_name": "Jefferson",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42067,
      "county_name": "Juniata",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42069,
      "county_name": "Lackawanna",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42071,
      "county_name": "Lancaster",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42073,
      "county_name": "Lawrence",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42075,
      "county_name": "Lebanon",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42077,
      "county_name": "Lehigh",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42079,
      "county_name": "Luzerne",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42081,
      "county_name": "Lycoming",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42083,
      "county_name": "McKean",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42085,
      "county_name": "Mercer",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42087,
      "county_name": "Mifflin",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42089,
      "county_name": "Monroe",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42091,
      "county_name": "Montgomery",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42093,
      "county_name": "Montour",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42095,
      "county_name": "Northampton",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42097,
      "county_name": "Northumberland",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42099,
      "county_name": "Perry",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42101,
      "county_name": "Philadelphia",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42103,
      "county_name": "Pike",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42105,
      "county_name": "Potter",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42107,
      "county_name": "Schuylkill",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42109,
      "county_name": "Snyder",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42111,
      "county_name": "Somerset",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42113,
      "county_name": "Sullivan",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42115,
      "county_name": "Susquehanna",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42117,
      "county_name": "Tioga",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42119,
      "county_name": "Union",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42121,
      "county_name": "Venango",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42123,
      "county_name": "Warren",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42125,
      "county_name": "Washington",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42127,
      "county_name": "Wayne",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42129,
      "county_name": "Westmoreland",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42131,
      "county_name": "Wyoming",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 42133,
      "county_name": "York",
      "state": "PA",
      "state_name": "Pennsylvania"
    },
    {
      "fip": 44001,
      "county_name": "Bristol",
      "state": "RI",
      "state_name": "Rhode Island"
    },
    {
      "fip": 44003,
      "county_name": "Kent",
      "state": "RI",
      "state_name": "Rhode Island"
    },
    {
      "fip": 44005,
      "county_name": "Newport",
      "state": "RI",
      "state_name": "Rhode Island"
    },
    {
      "fip": 44007,
      "county_name": "Providence",
      "state": "RI",
      "state_name": "Rhode Island"
    },
    {
      "fip": 44009,
      "county_name": "Washington",
      "state": "RI",
      "state_name": "Rhode Island"
    },
    {
      "fip": 45001,
      "county_name": "Abbeville",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45003,
      "county_name": "Aiken",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45005,
      "county_name": "Allendale",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45007,
      "county_name": "Anderson",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45009,
      "county_name": "Bamberg",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45011,
      "county_name": "Barnwell",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45013,
      "county_name": "Beaufort",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45015,
      "county_name": "Berkeley",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45017,
      "county_name": "Calhoun",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45019,
      "county_name": "Charleston",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45021,
      "county_name": "Cherokee",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45023,
      "county_name": "Chester",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45025,
      "county_name": "Chesterfield",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45027,
      "county_name": "Clarendon",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45029,
      "county_name": "Colleton",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45031,
      "county_name": "Darlington",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45033,
      "county_name": "Dillon",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45035,
      "county_name": "Dorchester",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45037,
      "county_name": "Edgefield",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45039,
      "county_name": "Fairfield",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45041,
      "county_name": "Florence",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45043,
      "county_name": "Georgetown",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45045,
      "county_name": "Greenville",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45047,
      "county_name": "Greenwood",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45049,
      "county_name": "Hampton",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45051,
      "county_name": "Horry",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45053,
      "county_name": "Jasper",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45055,
      "county_name": "Kershaw",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45057,
      "county_name": "Lancaster",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45059,
      "county_name": "Laurens",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45061,
      "county_name": "Lee",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45063,
      "county_name": "Lexington",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45065,
      "county_name": "McCormick",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45067,
      "county_name": "Marion",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45069,
      "county_name": "Marlboro",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45071,
      "county_name": "Newberry",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45073,
      "county_name": "Oconee",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45075,
      "county_name": "Orangeburg",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45077,
      "county_name": "Pickens",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45079,
      "county_name": "Richland",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45081,
      "county_name": "Saluda",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45083,
      "county_name": "Spartanburg",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45085,
      "county_name": "Sumter",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45087,
      "county_name": "Union",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45089,
      "county_name": "Williamsburg",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 45091,
      "county_name": "York",
      "state": "SC",
      "state_name": "South Carolina"
    },
    {
      "fip": 46003,
      "county_name": "Aurora",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46005,
      "county_name": "Beadle",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46007,
      "county_name": "Bennett",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46009,
      "county_name": "Bon Homme",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46011,
      "county_name": "Brookings",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46013,
      "county_name": "Brown",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46015,
      "county_name": "Brule",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46017,
      "county_name": "Buffalo",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46019,
      "county_name": "Butte",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46021,
      "county_name": "Campbell",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46023,
      "county_name": "Charles Mix",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46025,
      "county_name": "Clark",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46027,
      "county_name": "Clay",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46029,
      "county_name": "Codington",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46031,
      "county_name": "Corson",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46033,
      "county_name": "Custer",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46035,
      "county_name": "Davison",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46037,
      "county_name": "Day",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46039,
      "county_name": "Deuel",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46041,
      "county_name": "Dewey",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46043,
      "county_name": "Douglas",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46045,
      "county_name": "Edmunds",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46047,
      "county_name": "Fall River",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46049,
      "county_name": "Faulk",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46051,
      "county_name": "Grant",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46053,
      "county_name": "Gregory",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46055,
      "county_name": "Haakon",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46057,
      "county_name": "Hamlin",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46059,
      "county_name": "Hand",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46061,
      "county_name": "Hanson",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46063,
      "county_name": "Harding",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46065,
      "county_name": "Hughes",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46067,
      "county_name": "Hutchinson",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46069,
      "county_name": "Hyde",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46071,
      "county_name": "Jackson",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46073,
      "county_name": "Jerauld",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46075,
      "county_name": "Jones",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46077,
      "county_name": "Kingsbury",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46079,
      "county_name": "Lake",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46081,
      "county_name": "Lawrence",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46083,
      "county_name": "Lincoln",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46085,
      "county_name": "Lyman",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46087,
      "county_name": "McCook",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46089,
      "county_name": "McPherson",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46091,
      "county_name": "Marshall",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46093,
      "county_name": "Meade",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46095,
      "county_name": "Mellette",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46097,
      "county_name": "Miner",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46099,
      "county_name": "Minnehaha",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46101,
      "county_name": "Moody",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46102,
      "county_name": "Oglala Lakota",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46103,
      "county_name": "Pennington",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46105,
      "county_name": "Perkins",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46107,
      "county_name": "Potter",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46109,
      "county_name": "Roberts",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46111,
      "county_name": "Sanborn",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46113,
      "county_name": "Shannon",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46115,
      "county_name": "Spink",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46117,
      "county_name": "Stanley",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46119,
      "county_name": "Sully",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46121,
      "county_name": "Todd",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46123,
      "county_name": "Tripp",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46125,
      "county_name": "Turner",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46127,
      "county_name": "Union",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46129,
      "county_name": "Walworth",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46135,
      "county_name": "Yankton",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 46137,
      "county_name": "Ziebach",
      "state": "SD",
      "state_name": "South Dakota"
    },
    {
      "fip": 47001,
      "county_name": "Anderson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47003,
      "county_name": "Bedford",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47005,
      "county_name": "Benton",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47007,
      "county_name": "Bledsoe",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47009,
      "county_name": "Blount",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47011,
      "county_name": "Bradley",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47013,
      "county_name": "Campbell",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47015,
      "county_name": "Cannon",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47017,
      "county_name": "Carroll",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47019,
      "county_name": "Carter",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47021,
      "county_name": "Cheatham",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47023,
      "county_name": "Chester",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47025,
      "county_name": "Claiborne",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47027,
      "county_name": "Clay",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47029,
      "county_name": "Cocke",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47031,
      "county_name": "Coffee",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47033,
      "county_name": "Crockett",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47035,
      "county_name": "Cumberland",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47037,
      "county_name": "Davidson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47039,
      "county_name": "Decatur",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47041,
      "county_name": "DeKalb",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47043,
      "county_name": "Dickson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47045,
      "county_name": "Dyer",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47047,
      "county_name": "Fayette",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47049,
      "county_name": "Fentress",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47051,
      "county_name": "Franklin",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47053,
      "county_name": "Gibson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47055,
      "county_name": "Giles",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47057,
      "county_name": "Grainger",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47059,
      "county_name": "Greene",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47061,
      "county_name": "Grundy",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47063,
      "county_name": "Hamblen",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47065,
      "county_name": "Hamilton",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47067,
      "county_name": "Hancock",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47069,
      "county_name": "Hardeman",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47071,
      "county_name": "Hardin",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47073,
      "county_name": "Hawkins",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47075,
      "county_name": "Haywood",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47077,
      "county_name": "Henderson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47079,
      "county_name": "Henry",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47081,
      "county_name": "Hickman",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47083,
      "county_name": "Houston",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47085,
      "county_name": "Humphreys",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47087,
      "county_name": "Jackson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47089,
      "county_name": "Jefferson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47091,
      "county_name": "Johnson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47093,
      "county_name": "Knox",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47095,
      "county_name": "Lake",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47097,
      "county_name": "Lauderdale",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47099,
      "county_name": "Lawrence",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47101,
      "county_name": "Lewis",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47103,
      "county_name": "Lincoln",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47105,
      "county_name": "Loudon",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47107,
      "county_name": "McMinn",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47109,
      "county_name": "McNairy",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47111,
      "county_name": "Macon",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47113,
      "county_name": "Madison",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47115,
      "county_name": "Marion",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47117,
      "county_name": "Marshall",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47119,
      "county_name": "Maury",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47121,
      "county_name": "Meigs",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47123,
      "county_name": "Monroe",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47125,
      "county_name": "Montgomery",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47127,
      "county_name": "Moore",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47129,
      "county_name": "Morgan",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47131,
      "county_name": "Obion",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47133,
      "county_name": "Overton",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47135,
      "county_name": "Perry",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47137,
      "county_name": "Pickett",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47139,
      "county_name": "Polk",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47141,
      "county_name": "Putnam",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47143,
      "county_name": "Rhea",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47145,
      "county_name": "Roane",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47147,
      "county_name": "Robertson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47149,
      "county_name": "Rutherford",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47151,
      "county_name": "Scott",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47153,
      "county_name": "Sequatchie",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47155,
      "county_name": "Sevier",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47157,
      "county_name": "Shelby",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47159,
      "county_name": "Smith",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47161,
      "county_name": "Stewart",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47163,
      "county_name": "Sullivan",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47165,
      "county_name": "Sumner",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47167,
      "county_name": "Tipton",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47169,
      "county_name": "Trousdale",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47171,
      "county_name": "Unicoi",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47173,
      "county_name": "Union",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47175,
      "county_name": "Van Buren",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47177,
      "county_name": "Warren",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47179,
      "county_name": "Washington",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47181,
      "county_name": "Wayne",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47183,
      "county_name": "Weakley",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47185,
      "county_name": "White",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47187,
      "county_name": "Williamson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 47189,
      "county_name": "Wilson",
      "state": "TN",
      "state_name": "Tennessee"
    },
    {
      "fip": 48001,
      "county_name": "Anderson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48003,
      "county_name": "Andrews",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48005,
      "county_name": "Angelina",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48007,
      "county_name": "Aransas",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48009,
      "county_name": "Archer",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48011,
      "county_name": "Armstrong",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48013,
      "county_name": "Atascosa",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48015,
      "county_name": "Austin",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48017,
      "county_name": "Bailey",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48019,
      "county_name": "Bandera",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48021,
      "county_name": "Bastrop",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48023,
      "county_name": "Baylor",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48025,
      "county_name": "Bee",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48027,
      "county_name": "Bell",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48029,
      "county_name": "Bexar",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48031,
      "county_name": "Blanco",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48033,
      "county_name": "Borden",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48035,
      "county_name": "Bosque",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48037,
      "county_name": "Bowie",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48039,
      "county_name": "Brazoria",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48041,
      "county_name": "Brazos",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48043,
      "county_name": "Brewster",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48045,
      "county_name": "Briscoe",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48047,
      "county_name": "Brooks",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48049,
      "county_name": "Brown",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48051,
      "county_name": "Burleson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48053,
      "county_name": "Burnet",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48055,
      "county_name": "Caldwell",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48057,
      "county_name": "Calhoun",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48059,
      "county_name": "Callahan",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48061,
      "county_name": "Cameron",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48063,
      "county_name": "Camp",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48065,
      "county_name": "Carson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48067,
      "county_name": "Cass",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48069,
      "county_name": "Castro",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48071,
      "county_name": "Chambers",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48073,
      "county_name": "Cherokee",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48075,
      "county_name": "Childress",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48077,
      "county_name": "Clay",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48079,
      "county_name": "Cochran",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48081,
      "county_name": "Coke",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48083,
      "county_name": "Coleman",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48085,
      "county_name": "Collin",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48087,
      "county_name": "Collingsworth",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48089,
      "county_name": "Colorado",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48091,
      "county_name": "Comal",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48093,
      "county_name": "Comanche",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48095,
      "county_name": "Concho",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48097,
      "county_name": "Cooke",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48099,
      "county_name": "Coryell",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48101,
      "county_name": "Cottle",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48103,
      "county_name": "Crane",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48105,
      "county_name": "Crockett",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48107,
      "county_name": "Crosby",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48109,
      "county_name": "Culberson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48111,
      "county_name": "Dallam",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48113,
      "county_name": "Dallas",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48115,
      "county_name": "Dawson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48117,
      "county_name": "Deaf Smith",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48119,
      "county_name": "Delta",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48121,
      "county_name": "Denton",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48123,
      "county_name": "DeWitt",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48125,
      "county_name": "Dickens",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48127,
      "county_name": "Dimmit",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48129,
      "county_name": "Donley",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48131,
      "county_name": "Duval",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48133,
      "county_name": "Eastland",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48135,
      "county_name": "Ector",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48137,
      "county_name": "Edwards",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48139,
      "county_name": "Ellis",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48141,
      "county_name": "El Paso",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48143,
      "county_name": "Erath",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48145,
      "county_name": "Falls",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48147,
      "county_name": "Fannin",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48149,
      "county_name": "Fayette",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48151,
      "county_name": "Fisher",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48153,
      "county_name": "Floyd",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48155,
      "county_name": "Foard",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48157,
      "county_name": "Fort Bend",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48159,
      "county_name": "Franklin",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48161,
      "county_name": "Freestone",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48163,
      "county_name": "Frio",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48165,
      "county_name": "Gaines",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48167,
      "county_name": "Galveston",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48169,
      "county_name": "Garza",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48171,
      "county_name": "Gillespie",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48173,
      "county_name": "Glasscock",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48175,
      "county_name": "Goliad",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48177,
      "county_name": "Gonzales",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48179,
      "county_name": "Gray",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48181,
      "county_name": "Grayson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48183,
      "county_name": "Gregg",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48185,
      "county_name": "Grimes",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48187,
      "county_name": "Guadalupe",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48189,
      "county_name": "Hale",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48191,
      "county_name": "Hall",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48193,
      "county_name": "Hamilton",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48195,
      "county_name": "Hansford",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48197,
      "county_name": "Hardeman",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48199,
      "county_name": "Hardin",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48201,
      "county_name": "Harris",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48203,
      "county_name": "Harrison",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48205,
      "county_name": "Hartley",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48207,
      "county_name": "Haskell",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48209,
      "county_name": "Hays",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48211,
      "county_name": "Hemphill",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48213,
      "county_name": "Henderson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48215,
      "county_name": "Hidalgo",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48217,
      "county_name": "Hill",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48219,
      "county_name": "Hockley",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48221,
      "county_name": "Hood",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48223,
      "county_name": "Hopkins",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48225,
      "county_name": "Houston",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48227,
      "county_name": "Howard",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48229,
      "county_name": "Hudspeth",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48231,
      "county_name": "Hunt",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48233,
      "county_name": "Hutchinson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48235,
      "county_name": "Irion",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48237,
      "county_name": "Jack",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48239,
      "county_name": "Jackson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48241,
      "county_name": "Jasper",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48243,
      "county_name": "Jeff Davis",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48245,
      "county_name": "Jefferson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48247,
      "county_name": "Jim Hogg",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48249,
      "county_name": "Jim Wells",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48251,
      "county_name": "Johnson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48253,
      "county_name": "Jones",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48255,
      "county_name": "Karnes",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48257,
      "county_name": "Kaufman",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48259,
      "county_name": "Kendall",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48261,
      "county_name": "Kenedy",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48263,
      "county_name": "Kent",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48265,
      "county_name": "Kerr",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48267,
      "county_name": "Kimble",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48269,
      "county_name": "King",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48271,
      "county_name": "Kinney",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48273,
      "county_name": "Kleberg",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48275,
      "county_name": "Knox",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48277,
      "county_name": "Lamar",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48279,
      "county_name": "Lamb",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48281,
      "county_name": "Lampasas",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48283,
      "county_name": "La Salle",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48285,
      "county_name": "Lavaca",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48287,
      "county_name": "Lee",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48289,
      "county_name": "Leon",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48291,
      "county_name": "Liberty",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48293,
      "county_name": "Limestone",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48295,
      "county_name": "Lipscomb",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48297,
      "county_name": "Live Oak",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48299,
      "county_name": "Llano",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48301,
      "county_name": "Loving",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48303,
      "county_name": "Lubbock",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48305,
      "county_name": "Lynn",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48307,
      "county_name": "McCulloch",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48309,
      "county_name": "McLennan",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48311,
      "county_name": "McMullen",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48313,
      "county_name": "Madison",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48315,
      "county_name": "Marion",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48317,
      "county_name": "Martin",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48319,
      "county_name": "Mason",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48321,
      "county_name": "Matagorda",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48323,
      "county_name": "Maverick",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48325,
      "county_name": "Medina",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48327,
      "county_name": "Menard",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48329,
      "county_name": "Midland",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48331,
      "county_name": "Milam",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48333,
      "county_name": "Mills",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48335,
      "county_name": "Mitchell",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48337,
      "county_name": "Montague",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48339,
      "county_name": "Montgomery",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48341,
      "county_name": "Moore",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48343,
      "county_name": "Morris",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48345,
      "county_name": "Motley",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48347,
      "county_name": "Nacogdoches",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48349,
      "county_name": "Navarro",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48351,
      "county_name": "Newton",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48353,
      "county_name": "Nolan",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48355,
      "county_name": "Nueces",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48357,
      "county_name": "Ochiltree",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48359,
      "county_name": "Oldham",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48361,
      "county_name": "Orange",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48363,
      "county_name": "Palo Pinto",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48365,
      "county_name": "Panola",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48367,
      "county_name": "Parker",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48369,
      "county_name": "Parmer",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48371,
      "county_name": "Pecos",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48373,
      "county_name": "Polk",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48375,
      "county_name": "Potter",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48377,
      "county_name": "Presidio",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48379,
      "county_name": "Rains",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48381,
      "county_name": "Randall",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48383,
      "county_name": "Reagan",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48385,
      "county_name": "Real",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48387,
      "county_name": "Red River",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48389,
      "county_name": "Reeves",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48391,
      "county_name": "Refugio",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48393,
      "county_name": "Roberts",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48395,
      "county_name": "Robertson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48397,
      "county_name": "Rockwall",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48399,
      "county_name": "Runnels",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48401,
      "county_name": "Rusk",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48403,
      "county_name": "Sabine",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48405,
      "county_name": "San Augustine",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48407,
      "county_name": "San Jacinto",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48409,
      "county_name": "San Patricio",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48411,
      "county_name": "San Saba",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48413,
      "county_name": "Schleicher",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48415,
      "county_name": "Scurry",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48417,
      "county_name": "Shackelford",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48419,
      "county_name": "Shelby",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48421,
      "county_name": "Sherman",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48423,
      "county_name": "Smith",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48425,
      "county_name": "Somervell",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48427,
      "county_name": "Starr",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48429,
      "county_name": "Stephens",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48431,
      "county_name": "Sterling",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48433,
      "county_name": "Stonewall",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48435,
      "county_name": "Sutton",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48437,
      "county_name": "Swisher",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48439,
      "county_name": "Tarrant",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48441,
      "county_name": "Taylor",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48443,
      "county_name": "Terrell",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48445,
      "county_name": "Terry",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48447,
      "county_name": "Throckmorton",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48449,
      "county_name": "Titus",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48451,
      "county_name": "Tom Green",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48453,
      "county_name": "Travis",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48455,
      "county_name": "Trinity",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48457,
      "county_name": "Tyler",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48459,
      "county_name": "Upshur",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48461,
      "county_name": "Upton",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48463,
      "county_name": "Uvalde",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48465,
      "county_name": "Val Verde",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48467,
      "county_name": "Van Zandt",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48469,
      "county_name": "Victoria",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48471,
      "county_name": "Walker",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48473,
      "county_name": "Waller",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48475,
      "county_name": "Ward",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48477,
      "county_name": "Washington",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48479,
      "county_name": "Webb",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48481,
      "county_name": "Wharton",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48483,
      "county_name": "Wheeler",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48485,
      "county_name": "Wichita",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48487,
      "county_name": "Wilbarger",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48489,
      "county_name": "Willacy",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48491,
      "county_name": "Williamson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48493,
      "county_name": "Wilson",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48495,
      "county_name": "Winkler",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48497,
      "county_name": "Wise",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48499,
      "county_name": "Wood",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48501,
      "county_name": "Yoakum",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48503,
      "county_name": "Young",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48505,
      "county_name": "Zapata",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 48507,
      "county_name": "Zavala",
      "state": "TX",
      "state_name": "Texas"
    },
    {
      "fip": 49001,
      "county_name": "Beaver",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49003,
      "county_name": "Box Elder",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49005,
      "county_name": "Cache",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49007,
      "county_name": "Carbon",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49009,
      "county_name": "Daggett",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49011,
      "county_name": "Davis",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49013,
      "county_name": "Duchesne",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49015,
      "county_name": "Emery",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49017,
      "county_name": "Garfield",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49019,
      "county_name": "Grand",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49021,
      "county_name": "Iron",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49023,
      "county_name": "Juab",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49025,
      "county_name": "Kane",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49027,
      "county_name": "Millard",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49029,
      "county_name": "Morgan",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49031,
      "county_name": "Piute",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49033,
      "county_name": "Rich",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49035,
      "county_name": "Salt Lake",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49037,
      "county_name": "San Juan",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49039,
      "county_name": "Sanpete",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49041,
      "county_name": "Sevier",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49043,
      "county_name": "Summit",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49045,
      "county_name": "Tooele",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49047,
      "county_name": "Uintah",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49049,
      "county_name": "Utah",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49051,
      "county_name": "Wasatch",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49053,
      "county_name": "Washington",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49055,
      "county_name": "Wayne",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 49057,
      "county_name": "Weber",
      "state": "UT",
      "state_name": "Utah"
    },
    {
      "fip": 50001,
      "county_name": "Addison",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50003,
      "county_name": "Bennington",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50005,
      "county_name": "Caledonia",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50007,
      "county_name": "Chittenden",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50009,
      "county_name": "Essex",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50011,
      "county_name": "Franklin",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50013,
      "county_name": "Grand Isle",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50015,
      "county_name": "Lamoille",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50017,
      "county_name": "Orange",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50019,
      "county_name": "Orleans",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50021,
      "county_name": "Rutland",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50023,
      "county_name": "Washington",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50025,
      "county_name": "Windham",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 50027,
      "county_name": "Windsor",
      "state": "VT",
      "state_name": "Vermont"
    },
    {
      "fip": 51001,
      "county_name": "Accomack",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51003,
      "county_name": "Albemarle",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51005,
      "county_name": "Alleghany",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51007,
      "county_name": "Amelia",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51009,
      "county_name": "Amherst",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51011,
      "county_name": "Appomattox",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51013,
      "county_name": "Arlington",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51015,
      "county_name": "Augusta",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51017,
      "county_name": "Bath",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51019,
      "county_name": "Bedford",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51021,
      "county_name": "Bland",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51023,
      "county_name": "Botetourt",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51025,
      "county_name": "Brunswick",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51027,
      "county_name": "Buchanan",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51029,
      "county_name": "Buckingham",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51031,
      "county_name": "Campbell",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51033,
      "county_name": "Caroline",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51035,
      "county_name": "Carroll",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51036,
      "county_name": "Charles City",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51037,
      "county_name": "Charlotte",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51041,
      "county_name": "Chesterfield",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51043,
      "county_name": "Clarke",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51045,
      "county_name": "Craig",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51047,
      "county_name": "Culpeper",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51049,
      "county_name": "Cumberland",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51051,
      "county_name": "Dickenson",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51053,
      "county_name": "Dinwiddie",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51057,
      "county_name": "Essex",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51059,
      "county_name": "Fairfax",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51061,
      "county_name": "Fauquier",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51063,
      "county_name": "Floyd",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51065,
      "county_name": "Fluvanna",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51067,
      "county_name": "Franklin",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51069,
      "county_name": "Frederick",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51071,
      "county_name": "Giles",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51073,
      "county_name": "Gloucester",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51075,
      "county_name": "Goochland",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51077,
      "county_name": "Grayson",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51079,
      "county_name": "Greene",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51081,
      "county_name": "Greensville",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51083,
      "county_name": "Halifax",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51085,
      "county_name": "Hanover",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51087,
      "county_name": "Henrico",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51089,
      "county_name": "Henry",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51091,
      "county_name": "Highland",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51093,
      "county_name": "Isle of Wight",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51095,
      "county_name": "James City",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51097,
      "county_name": "King and Queen",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51099,
      "county_name": "King George",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51101,
      "county_name": "King William",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51103,
      "county_name": "Lancaster",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51105,
      "county_name": "Lee",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51107,
      "county_name": "Loudoun",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51109,
      "county_name": "Louisa",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51111,
      "county_name": "Lunenburg",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51113,
      "county_name": "Madison",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51115,
      "county_name": "Mathews",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51117,
      "county_name": "Mecklenburg",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51119,
      "county_name": "Middlesex",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51121,
      "county_name": "Montgomery",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51125,
      "county_name": "Nelson",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51127,
      "county_name": "New Kent",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51131,
      "county_name": "Northampton",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51133,
      "county_name": "Northumberland",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51135,
      "county_name": "Nottoway",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51137,
      "county_name": "Orange",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51139,
      "county_name": "Page",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51141,
      "county_name": "Patrick",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51143,
      "county_name": "Pittsylvania",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51145,
      "county_name": "Powhatan",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51147,
      "county_name": "Prince Edward",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51149,
      "county_name": "Prince George",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51153,
      "county_name": "Prince William",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51155,
      "county_name": "Pulaski",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51157,
      "county_name": "Rappahannock",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51159,
      "county_name": "Richmond",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51161,
      "county_name": "Roanoke",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51163,
      "county_name": "Rockbridge",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51165,
      "county_name": "Rockingham",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51167,
      "county_name": "Russell",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51169,
      "county_name": "Scott",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51171,
      "county_name": "Shenandoah",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51173,
      "county_name": "Smyth",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51175,
      "county_name": "Southampton",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51177,
      "county_name": "Spotsylvania",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51179,
      "county_name": "Stafford",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51181,
      "county_name": "Surry",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51183,
      "county_name": "Sussex",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51185,
      "county_name": "Tazewell",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51187,
      "county_name": "Warren",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51191,
      "county_name": "Washington",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51193,
      "county_name": "Westmoreland",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51195,
      "county_name": "Wise",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51197,
      "county_name": "Wythe",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51199,
      "county_name": "York",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51510,
      "county_name": "Alexandria city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51515,
      "county_name": "Bedford city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51520,
      "county_name": "Bristol city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51530,
      "county_name": "Buena Vista city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51540,
      "county_name": "Charlottesville city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51550,
      "county_name": "Chesapeake city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51570,
      "county_name": "Colonial Heights city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51580,
      "county_name": "Covington city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51590,
      "county_name": "Danville city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51595,
      "county_name": "Emporia city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51600,
      "county_name": "Fairfax city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51610,
      "county_name": "Falls Church city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51620,
      "county_name": "Franklin city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51630,
      "county_name": "Fredericksburg city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51640,
      "county_name": "Galax city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51650,
      "county_name": "Hampton city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51660,
      "county_name": "Harrisonburg city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51670,
      "county_name": "Hopewell city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51678,
      "county_name": "Lexington city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51680,
      "county_name": "Lynchburg city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51683,
      "county_name": "Manassas city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51685,
      "county_name": "Manassas Park city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51690,
      "county_name": "Martinsville city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51700,
      "county_name": "Newport News city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51710,
      "county_name": "Norfolk city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51720,
      "county_name": "Norton city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51730,
      "county_name": "Petersburg city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51735,
      "county_name": "Poquoson city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51740,
      "county_name": "Portsmouth city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51750,
      "county_name": "Radford city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51760,
      "county_name": "Richmond city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51770,
      "county_name": "Roanoke city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51775,
      "county_name": "Salem city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51790,
      "county_name": "Staunton city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51800,
      "county_name": "Suffolk city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51810,
      "county_name": "Virginia Beach city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51820,
      "county_name": "Waynesboro city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51830,
      "county_name": "Williamsburg city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 51840,
      "county_name": "Winchester city",
      "state": "VA",
      "state_name": "Virginia"
    },
    {
      "fip": 53001,
      "county_name": "Adams",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53003,
      "county_name": "Asotin",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53005,
      "county_name": "Benton",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53007,
      "county_name": "Chelan",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53009,
      "county_name": "Clallam",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53011,
      "county_name": "Clark",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53013,
      "county_name": "Columbia",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53015,
      "county_name": "Cowlitz",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53017,
      "county_name": "Douglas",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53019,
      "county_name": "Ferry",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53021,
      "county_name": "Franklin",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53023,
      "county_name": "Garfield",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53025,
      "county_name": "Grant",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53027,
      "county_name": "Grays Harbor",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53029,
      "county_name": "Island",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53031,
      "county_name": "Jefferson",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53033,
      "county_name": "King",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53035,
      "county_name": "Kitsap",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53037,
      "county_name": "Kittitas",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53039,
      "county_name": "Klickitat",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53041,
      "county_name": "Lewis",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53043,
      "county_name": "Lincoln",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53045,
      "county_name": "Mason",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53047,
      "county_name": "Okanogan",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53049,
      "county_name": "Pacific",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53051,
      "county_name": "Pend Oreille",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53053,
      "county_name": "Pierce",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53055,
      "county_name": "San Juan",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53057,
      "county_name": "Skagit",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53059,
      "county_name": "Skamania",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53061,
      "county_name": "Snohomish",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53063,
      "county_name": "Spokane",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53065,
      "county_name": "Stevens",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53067,
      "county_name": "Thurston",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53069,
      "county_name": "Wahkiakum",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53071,
      "county_name": "Walla Walla",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53073,
      "county_name": "Whatcom",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53075,
      "county_name": "Whitman",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 53077,
      "county_name": "Yakima",
      "state": "WA",
      "state_name": "Washington"
    },
    {
      "fip": 54001,
      "county_name": "Barbour",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54003,
      "county_name": "Berkeley",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54005,
      "county_name": "Boone",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54007,
      "county_name": "Braxton",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54009,
      "county_name": "Brooke",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54011,
      "county_name": "Cabell",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54013,
      "county_name": "Calhoun",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54015,
      "county_name": "Clay",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54017,
      "county_name": "Doddridge",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54019,
      "county_name": "Fayette",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54021,
      "county_name": "Gilmer",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54023,
      "county_name": "Grant",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54025,
      "county_name": "Greenbrier",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54027,
      "county_name": "Hampshire",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54029,
      "county_name": "Hancock",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54031,
      "county_name": "Hardy",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54033,
      "county_name": "Harrison",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54035,
      "county_name": "Jackson",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54037,
      "county_name": "Jefferson",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54039,
      "county_name": "Kanawha",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54041,
      "county_name": "Lewis",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54043,
      "county_name": "Lincoln",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54045,
      "county_name": "Logan",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54047,
      "county_name": "McDowell",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54049,
      "county_name": "Marion",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54051,
      "county_name": "Marshall",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54053,
      "county_name": "Mason",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54055,
      "county_name": "Mercer",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54057,
      "county_name": "Mineral",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54059,
      "county_name": "Mingo",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54061,
      "county_name": "Monongalia",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54063,
      "county_name": "Monroe",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54065,
      "county_name": "Morgan",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54067,
      "county_name": "Nicholas",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54069,
      "county_name": "Ohio",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54071,
      "county_name": "Pendleton",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54073,
      "county_name": "Pleasants",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54075,
      "county_name": "Pocahontas",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54077,
      "county_name": "Preston",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54079,
      "county_name": "Putnam",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54081,
      "county_name": "Raleigh",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54083,
      "county_name": "Randolph",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54085,
      "county_name": "Ritchie",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54087,
      "county_name": "Roane",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54089,
      "county_name": "Summers",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54091,
      "county_name": "Taylor",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54093,
      "county_name": "Tucker",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54095,
      "county_name": "Tyler",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54097,
      "county_name": "Upshur",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54099,
      "county_name": "Wayne",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54101,
      "county_name": "Webster",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54103,
      "county_name": "Wetzel",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54105,
      "county_name": "Wirt",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54107,
      "county_name": "Wood",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 54109,
      "county_name": "Wyoming",
      "state": "WV",
      "state_name": "West Virginia"
    },
    {
      "fip": 55001,
      "county_name": "Adams",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55003,
      "county_name": "Ashland",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55005,
      "county_name": "Barron",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55007,
      "county_name": "Bayfield",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55009,
      "county_name": "Brown",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55011,
      "county_name": "Buffalo",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55013,
      "county_name": "Burnett",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55015,
      "county_name": "Calumet",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55017,
      "county_name": "Chippewa",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55019,
      "county_name": "Clark",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55021,
      "county_name": "Columbia",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55023,
      "county_name": "Crawford",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55025,
      "county_name": "Dane",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55027,
      "county_name": "Dodge",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55029,
      "county_name": "Door",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55031,
      "county_name": "Douglas",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55033,
      "county_name": "Dunn",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55035,
      "county_name": "Eau Claire",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55037,
      "county_name": "Florence",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55039,
      "county_name": "Fond du Lac",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55041,
      "county_name": "Forest",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55043,
      "county_name": "Grant",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55045,
      "county_name": "Green",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55047,
      "county_name": "Green Lake",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55049,
      "county_name": "Iowa",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55051,
      "county_name": "Iron",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55053,
      "county_name": "Jackson",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55055,
      "county_name": "Jefferson",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55057,
      "county_name": "Juneau",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55059,
      "county_name": "Kenosha",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55061,
      "county_name": "Kewaunee",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55063,
      "county_name": "La Crosse",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55065,
      "county_name": "Lafayette",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55067,
      "county_name": "Langlade",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55069,
      "county_name": "Lincoln",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55071,
      "county_name": "Manitowoc",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55073,
      "county_name": "Marathon",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55075,
      "county_name": "Marinette",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55077,
      "county_name": "Marquette",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55078,
      "county_name": "Menominee",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55079,
      "county_name": "Milwaukee",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55081,
      "county_name": "Monroe",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55083,
      "county_name": "Oconto",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55085,
      "county_name": "Oneida",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55087,
      "county_name": "Outagamie",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55089,
      "county_name": "Ozaukee",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55091,
      "county_name": "Pepin",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55093,
      "county_name": "Pierce",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55095,
      "county_name": "Polk",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55097,
      "county_name": "Portage",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55099,
      "county_name": "Price",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55101,
      "county_name": "Racine",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55103,
      "county_name": "Richland",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55105,
      "county_name": "Rock",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55107,
      "county_name": "Rusk",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55109,
      "county_name": "St. Croix",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55111,
      "county_name": "Sauk",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55113,
      "county_name": "Sawyer",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55115,
      "county_name": "Shawano",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55117,
      "county_name": "Sheboygan",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55119,
      "county_name": "Taylor",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55121,
      "county_name": "Trempealeau",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55123,
      "county_name": "Vernon",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55125,
      "county_name": "Vilas",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55127,
      "county_name": "Walworth",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55129,
      "county_name": "Washburn",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55131,
      "county_name": "Washington",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55133,
      "county_name": "Waukesha",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55135,
      "county_name": "Waupaca",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55137,
      "county_name": "Waushara",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55139,
      "county_name": "Winnebago",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 55141,
      "county_name": "Wood",
      "state": "WI",
      "state_name": "Wisconsin"
    },
    {
      "fip": 56001,
      "county_name": "Albany",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56003,
      "county_name": "Big Horn",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56005,
      "county_name": "Campbell",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56007,
      "county_name": "Carbon",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56009,
      "county_name": "Converse",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56011,
      "county_name": "Crook",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56013,
      "county_name": "Fremont",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56015,
      "county_name": "Goshen",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56017,
      "county_name": "Hot Springs",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56019,
      "county_name": "Johnson",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56021,
      "county_name": "Laramie",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56023,
      "county_name": "Lincoln",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56025,
      "county_name": "Natrona",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56027,
      "county_name": "Niobrara",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56029,
      "county_name": "Park",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56031,
      "county_name": "Platte",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56033,
      "county_name": "Sheridan",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56035,
      "county_name": "Sublette",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56037,
      "county_name": "Sweetwater",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56039,
      "county_name": "Teton",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56041,
      "county_name": "Uinta",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56043,
      "county_name": "Washakie",
      "state": "WY",
      "state_name": "Wyoming"
    },
    {
      "fip": 56045,
      "county_name": "Weston",
      "state": "WY",
      "state_name": "Wyoming"
    }
]

export default Counties
    .map(a => {
        let label = a.county_name + ', ' + a.state
        let value = (a.fip < 10000 ? '0' : '') + String(a.fip)
        let state = a.state
        return {value, label, state}
    })



// WEBPACK FOOTER //
// ./src/municipals/market-news/custom-search/counties.js